// eslint-disable-next-line unicorn/prefer-module
const { defineMessages } = require('react-intl');

// eslint-disable-next-line unicorn/prefer-module
module.exports = defineMessages({
  argentina: {
    id: 'argentina',
    defaultMessage: 'Argentina',
  },
  australia: {
    id: 'australia',
    defaultMessage: 'Australia',
  },
  austria: {
    id: 'austria',
    defaultMessage: 'Austria',
  },
  belgiumFr: {
    id: 'belgiumFr',
    defaultMessage: 'Belgium FR',
  },
  belgiumNl: {
    id: 'belgiumNl',
    defaultMessage: 'Belgium NL',
  },
  brazil: {
    id: 'brazil',
    defaultMessage: 'Brazil',
  },
  canadaEn: {
    id: 'canadaEn',
    defaultMessage: 'Canada EN',
  },
  canadaFr: {
    id: 'canadaFr',
    defaultMessage: 'Canada FR',
  },
  chile: {
    id: 'chile',
    defaultMessage: 'Chile',
  },
  china: {
    id: 'china',
    defaultMessage: 'China',
  },
  colombia: {
    id: 'colombia',
    defaultMessage: 'Colombia',
  },
  czechia: {
    id: 'czechia',
    defaultMessage: 'Czechia',
  },
  denmark: {
    id: 'denmark',
    defaultMessage: 'Denmark',
  },
  finland: {
    id: 'finland',
    defaultMessage: 'Finland',
  },
  france: {
    id: 'france',
    defaultMessage: 'France',
  },
  germany: {
    id: 'germany',
    defaultMessage: 'Germany',
  },
  hongKong: {
    id: 'hongKong',
    defaultMessage: 'Hong Kong',
  },
  hungary: {
    id: 'hungary',
    defaultMessage: 'Hungary',
  },
  india: {
    id: 'india',
    defaultMessage: 'India',
  },
  ireland: {
    id: 'ireland',
    defaultMessage: 'Ireland',
  },
  italy: {
    id: 'italy',
    defaultMessage: 'Italy',
  },
  japan: {
    id: 'japan',
    defaultMessage: 'Japan',
  },
  luxembourg: {
    id: 'luxembourg',
    defaultMessage: 'Luxembourg',
  },
  mexico: {
    id: 'mexico',
    defaultMessage: 'Mexico',
  },
  newZealand: {
    id: 'newZealand',
    defaultMessage: 'New Zealand',
  },
  norway: {
    id: 'norway',
    defaultMessage: 'Norway',
  },
  peru: {
    id: 'peru',
    defaultMessage: 'Peru',
  },
  poland: {
    id: 'poland',
    defaultMessage: 'Poland',
  },
  portugal: {
    id: 'portugal',
    defaultMessage: 'Portugal',
  },
  russia: {
    id: 'russia',
    defaultMessage: 'Russia',
  },
  spain: {
    id: 'spain',
    defaultMessage: 'Spain',
  },
  sweden: {
    id: 'sweden',
    defaultMessage: 'Sweden',
  },
  switzerland: {
    id: 'switzerland',
    defaultMessage: 'Switzerland',
  },
  theNetherlands: {
    id: 'theNetherlands',
    defaultMessage: 'The Netherlands',
  },
  turkey: {
    id: 'turkey',
    defaultMessage: 'Turkey',
  },
  unitedKingdom: {
    id: 'unitedKingdom',
    defaultMessage: 'United Kingdom',
  },
  unitedStates: {
    id: 'unitedStates',
    defaultMessage: 'United States',
  },
  moreNews: {
    id: 'moreNews',
    defaultMessage: 'More News',
  },
  mostRead: {
    id: 'mostRead',
    defaultMessage: 'Most Read',
  },
  relatedNews: {
    id: 'relatedNews',
    defaultMessage: 'Related News',
  },
  topStories: {
    id: 'topStories',
    defaultMessage: 'Top Stories',
  },
  financialNews: {
    id: 'financialNews',
    defaultMessage: 'Financial News',
  },
  latestJobs: {
    id: 'latestJobs',
    defaultMessage: 'Latest Jobs',
  },
  jobOfTheWeek: {
    id: 'jobOfTheWeek',
    defaultMessage: 'Job Of The Week',
  },
  managementJobs: {
    id: 'managementJobs',
    defaultMessage: 'Management Jobs',
  },
  categories: {
    id: 'categories',
    defaultMessage: 'Categories',
  },
  applyButtonText: {
    id: 'applyButtonText',
    defaultMessage: 'Apply Here',
  },
  featured: {
    id: 'featured',
    defaultMessage: 'Featured',
  },
  partnerContent: {
    id: 'partnerContent',
    defaultMessage: 'Partner Content',
  },
  category: {
    id: 'category',
    defaultMessage: 'Category',
  },
  'category.news.fashion': {
    id: 'category.news.fashion',
    defaultMessage: 'Fashion',
  },
  'category.news.fashion.href': {
    id: 'category.news.fashion.href',
    defaultMessage: '/news/fashion',
  },
  'category.news.fashion.param': {
    id: 'category.news.fashion.param',
    defaultMessage: 'news/fashion',
  },
  'category.news.retail': {
    id: 'category.news.retail',
    defaultMessage: 'Retail',
  },
  'category.news.retail.href': {
    id: 'category.news.retail.href',
    defaultMessage: '/news/retail',
  },
  'category.news.retail.param': {
    id: 'category.news.retail.param',
    defaultMessage: 'news/retail',
  },
  'category.news.business': {
    id: 'category.news.business',
    defaultMessage: 'Business',
  },
  'category.news.business.href': {
    id: 'category.news.business.href',
    defaultMessage: '/news/business',
  },
  'category.news.business.param': {
    id: 'category.news.business.param',
    defaultMessage: 'news/business',
  },
  'category.news.culture': {
    id: 'category.news.culture',
    defaultMessage: 'Culture',
  },
  'category.news.culture.href': {
    id: 'category.news.culture.href',
    defaultMessage: '/news/culture',
  },
  'category.news.culture.param': {
    id: 'category.news.culture.param',
    defaultMessage: 'news/culture',
  },
  'category.news.people': {
    id: 'category.news.people',
    defaultMessage: 'People',
  },
  'category.news.people.href': {
    id: 'category.news.people.href',
    defaultMessage: '/news/people',
  },
  'category.news.people.param': {
    id: 'category.news.people.param',
    defaultMessage: 'news/people',
  },
  'category.news.fairs': {
    id: 'category.news.fairs',
    defaultMessage: 'Fairs',
  },
  'category.news.fairs.href': {
    id: 'category.news.fairs.href',
    defaultMessage: '/news/fairs',
  },
  'category.news.fairs.param': {
    id: 'category.news.fairs.param',
    defaultMessage: 'news/fairs',
  },
  'category.news.background': {
    id: 'category.news.background',
    defaultMessage: 'Background',
  },
  'category.news.background.href': {
    id: 'category.news.background.href',
    defaultMessage: '/news/background',
  },
  'category.news.background.param': {
    id: 'category.news.background.param',
    defaultMessage: 'news/background',
  },
  'category.news.video': {
    id: 'category.news.video',
    defaultMessage: 'Video',
  },
  'category.news.video.href': {
    id: 'category.news.video.href',
    defaultMessage: '/news/video',
  },
  'category.news.video.param': {
    id: 'category.news.video.param',
    defaultMessage: 'news/video',
  },
  'category.news.podcast': {
    id: 'category.news.podcast',
    defaultMessage: 'Podcast',
  },
  'category.news.podcast.href': {
    id: 'category.news.podcast.href',
    defaultMessage: '/news/podcast',
  },
  'category.news.podcast.param': {
    id: 'category.news.podcast.param',
    defaultMessage: 'news/podcast',
  },
  'category.education.news': {
    id: 'category.education.news',
    defaultMessage: 'News',
  },
  'category.education.news.href': {
    id: 'category.education.news.href',
    defaultMessage: '/education/news',
  },
  'category.education.schools': {
    id: 'category.education.schools',
    defaultMessage: 'Schools',
  },
  'category.education.schools.href': {
    id: 'category.education.schools.href',
    defaultMessage: '/education/schools',
  },
  'category.executive.report': {
    id: 'category.executive.report',
    defaultMessage: 'Report',
  },
  'category.executive.report.href': {
    id: 'category.executive.report.href',
    defaultMessage: '/executive/report',
  },
  'category.executive.management': {
    id: 'category.executive.management',
    defaultMessage: 'Management',
  },
  'category.executive.management.href': {
    id: 'category.executive.management.href',
    defaultMessage: '/executive/management',
  },
  'category.press': {
    id: 'category.press',
    defaultMessage: 'Press',
  },
  'category.press.href': {
    id: 'category.press.href',
    defaultMessage: '/press',
  },
  'category.press.param': {
    id: 'category.press.param',
    defaultMessage: 'press',
  },
  'category.press.fashion': {
    id: 'category.press.fashion',
    defaultMessage: 'Fashion',
  },
  'category.press.fashion.href': {
    id: 'category.press.fashion.href',
    defaultMessage: '/press/fashion',
  },
  'category.press.retail': {
    id: 'category.press.retail',
    defaultMessage: 'Retail',
  },
  'category.press.retail.href': {
    id: 'category.press.retail.href',
    defaultMessage: '/press/retail',
  },
  'category.press.business': {
    id: 'category.press.business',
    defaultMessage: 'Business',
  },
  'category.press.business.href': {
    id: 'category.press.business.href',
    defaultMessage: '/press/business',
  },
  'category.press.people': {
    id: 'category.press.people',
    defaultMessage: 'People',
  },
  'category.press.people.href': {
    id: 'category.press.people.href',
    defaultMessage: '/press/people',
  },
  'category.press.culture': {
    id: 'category.press.culture',
    defaultMessage: 'Culture',
  },
  'category.press.culture.href': {
    id: 'category.press.culture.href',
    defaultMessage: '/press/culture',
  },
  'category.press.research': {
    id: 'category.press.research',
    defaultMessage: 'Research',
  },
  'category.press.research.href': {
    id: 'category.press.research.href',
    defaultMessage: '/press/research',
  },
  'category.press.celebrity': {
    id: 'category.press.celebrity',
    defaultMessage: 'Celebrity',
  },
  'category.press.celebrity.href': {
    id: 'category.press.celebrity.href',
    defaultMessage: '/press/celebrity',
  },
  'category.press.event': {
    id: 'category.press.event',
    defaultMessage: 'Event',
  },
  'category.press.event.href': {
    id: 'category.press.event.href',
    defaultMessage: '/press/event',
  },
  'category.tags.beauty': {
    id: 'category.tags.beauty',
    defaultMessage: 'Beauty',
  },
  'category.tags.beauty.param': {
    id: 'category.tags.beauty.param',
    defaultMessage: 'beauty',
  },
  'category.tags.bodyFashion': {
    id: 'category.tags.bodyFashion',
    defaultMessage: 'Body Fashion',
  },
  'category.tags.bodyFashion.param': {
    id: 'category.tags.bodyFashion.param',
    defaultMessage: 'body-fashion',
  },
  'category.tags.colours': {
    id: 'category.tags.colours',
    defaultMessage: 'Colours',
  },
  'category.tags.colours.param': {
    id: 'category.tags.colours.param',
    defaultMessage: 'colours',
  },
  'category.tags.denim': {
    id: 'category.tags.denim',
    defaultMessage: 'Denim',
  },
  'category.tags.denim.param': {
    id: 'category.tags.denim.param',
    defaultMessage: 'denim',
  },
  'category.tags.digitalFashion': {
    id: 'category.tags.digitalFashion',
    defaultMessage: 'Digital Fashion',
  },
  'category.tags.digitalFashion.param': {
    id: 'category.tags.digitalFashion.param',
    defaultMessage: 'digital-fashion',
  },
  'category.tags.footwear': {
    id: 'category.tags.footwear',
    defaultMessage: 'Footwear',
  },
  'category.tags.footwear.param': {
    id: 'category.tags.footwear.param',
    defaultMessage: 'footwear',
  },
  'category.tags.kids': {
    id: 'category.tags.kids',
    defaultMessage: 'Kids',
  },
  'category.tags.kids.param': {
    id: 'category.tags.kids.param',
    defaultMessage: 'kids',
  },
  'category.tags.menswear': {
    id: 'category.tags.menswear',
    defaultMessage: 'Menswear',
  },
  'category.tags.menswear.param': {
    id: 'category.tags.menswear.param',
    defaultMessage: 'menswear',
  },
  'category.tags.parade': {
    id: 'category.tags.parade',
    defaultMessage: 'Parade',
  },
  'category.tags.parade.param': {
    id: 'category.tags.parade.param',
    defaultMessage: 'parade',
  },
  'category.tags.season.param': {
    id: 'category.tags.season.param',
    defaultMessage: 'season',
  },
  'category.tags.trends.param': {
    id: 'category.tags.trends.param',
    defaultMessage: 'trends',
  },
  'category.tags.womenswear': {
    id: 'category.tags.womenswear',
    defaultMessage: 'Womenswear',
  },
  'category.tags.womenswear.param': {
    id: 'category.tags.womenswear.param',
    defaultMessage: 'womenswear',
  },
  features: {
    id: 'features',
    defaultMessage: 'Features',
  },
  internationalNetwork: {
    id: 'internationalNetwork',
    defaultMessage: 'International Network',
  },
  careers: {
    id: 'careers',
    defaultMessage: 'Careers',
  },
  conditions: {
    id: 'conditions',
    defaultMessage: 'Conditions',
  },
  info: {
    id: 'info',
    defaultMessage: 'Info',
  },
  'info.features.news': {
    id: 'info.features.news',
    defaultMessage: 'News',
  },
  'info.features.newsletter': {
    id: 'info.features.newsletter',
    defaultMessage: 'Newsletter',
  },
  'info.features.careerCenter': {
    id: 'info.features.careerCenter',
    defaultMessage: 'Career Center',
  },
  'info.features.fashionWeekWeb': {
    id: 'info.features.fashionWeekWeb',
    defaultMessage: 'Fashion Week Web',
  },
  'info.features.media': {
    id: 'info.features.media',
    defaultMessage: 'Media',
  },
  'info.features.businessIntelligence': {
    id: 'info.features.businessIntelligence',
    defaultMessage: 'Business Intelligence',
  },
  'info.features.companyDirectory': {
    id: 'info.features.companyDirectory',
    defaultMessage: 'Company Directory',
  },
  'info.features.education': {
    id: 'info.features.education',
    defaultMessage: 'Education',
  },
  'info.about': {
    id: 'info.about',
    defaultMessage: 'About Us',
  },
  'info.about.mediaReleases': {
    id: 'info.about.mediaReleases',
    defaultMessage: 'Media Releases',
  },
  'info.conditions': {
    id: 'info.conditions',
    defaultMessage: 'Conditions',
  },
  'info.conditions.termsOfUse': {
    id: 'info.conditions.termsOfUse',
    defaultMessage: 'Terms of Use',
  },
  'jobs.category.all-categories.label': {
    id: 'jobs.category.all-categories.label',
    defaultMessage: 'All Categories',
  },
  'jobs.category.all-categories.description': {
    id: 'jobs.category.all-categories.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for fashion jobs or an other challenge in the fashion industry?',
  },
  'jobs.category.all-categories.introduction': {
    id: 'jobs.category.all-categories.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for fashion jobs? Start your new professional life here.',
  },
  'jobs.category.all-categories.title': {
    id: 'jobs.category.all-categories.title',
    defaultMessage: 'Fashion jobs',
  },
  'jobs.category.design-and-creative.param': {
    id: 'jobs.category.design-and-creative.param',
    defaultMessage: 'design-and-creative',
  },
  'jobs.category.design-and-creative.label': {
    id: 'jobs.category.design-and-creative.label',
    defaultMessage: 'Design & Creative',
  },
  'jobs.category.design-and-creative.description': {
    id: 'jobs.category.design-and-creative.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for creative and design jobs in the fashion industry?',
  },
  'jobs.category.design-and-creative.introduction': {
    id: 'jobs.category.design-and-creative.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for fashion design jobs? Start your creative fashion life here.',
  },
  'jobs.category.design-and-creative.title': {
    id: 'jobs.category.design-and-creative.title',
    defaultMessage: 'Creative & design jobs in fashion',
  },
  'jobs.category.internships.param': {
    id: 'jobs.category.internships.param',
    defaultMessage: 'internships',
  },
  'jobs.category.internships.label': {
    id: 'jobs.category.internships.label',
    defaultMessage: 'Internships',
  },
  'jobs.category.internships.description': {
    id: 'jobs.category.internships.description',
    defaultMessage: 'Looking for internships in the fashion industry?',
  },
  'jobs.category.internships.introduction': {
    id: 'jobs.category.internships.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for fashion internships? Start your fashion career here.',
  },
  'jobs.category.internships.title': {
    id: 'jobs.category.internships.title',
    defaultMessage: 'Internships in the fashion industry',
  },
  'jobs.category.other.param': {
    id: 'jobs.category.other.param',
    defaultMessage: 'other',
  },
  'jobs.category.other.label': {
    id: 'jobs.category.other.label',
    defaultMessage: 'Other',
  },
  'jobs.category.other.description': {
    id: 'jobs.category.other.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for fashion jobs or an other challenge in the fashion industry?',
  },
  'jobs.category.other.introduction': {
    id: 'jobs.category.other.introduction',
    defaultMessage: 'Looking for various fashion jobs? Start your career here.',
  },
  'jobs.category.other.title': {
    id: 'jobs.category.other.title',
    defaultMessage: 'Other jobs in fashion',
  },
  'jobs.category.product-and-supply-chain.param': {
    id: 'jobs.category.product-and-supply-chain.param',
    defaultMessage: 'product-and-supply-chain',
  },
  'jobs.category.product-and-supply-chain.label': {
    id: 'jobs.category.product-and-supply-chain.label',
    defaultMessage: 'Product & Supply Chain',
  },
  'jobs.category.product-and-supply-chain.description': {
    id: 'jobs.category.product-and-supply-chain.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for product and supply chain jobs in the fashion industry?',
  },
  'jobs.category.product-and-supply-chain.introduction': {
    id: 'jobs.category.product-and-supply-chain.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for supply chain jobs in fashion? Start your new professional life here.',
  },
  'jobs.category.product-and-supply-chain.title': {
    id: 'jobs.category.product-and-supply-chain.title',
    defaultMessage: 'Product & supply chain jobs in fashion',
  },
  'jobs.category.retail-management-and-in-store.param': {
    id: 'jobs.category.retail-management-and-in-store.param',
    defaultMessage: 'retail-management-and-in-store',
  },
  'jobs.category.retail-management-and-in-store.label': {
    id: 'jobs.category.retail-management-and-in-store.label',
    defaultMessage: 'Retail Management & In-store',
  },
  'jobs.category.retail-management-and-in-store.description': {
    id: 'jobs.category.retail-management-and-in-store.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for retail management and in-store jobs in the fashion industry?',
  },
  'jobs.category.retail-management-and-in-store.introduction': {
    id: 'jobs.category.retail-management-and-in-store.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for retail management & in-store jobs in the fashion industry? Start your fashion career here.',
  },
  'jobs.category.retail-management-and-in-store.title': {
    id: 'jobs.category.retail-management-and-in-store.title',
    defaultMessage: 'Retail management & in-store jobs in fashion',
  },
  'jobs.category.sales-and-marketing.param': {
    id: 'jobs.category.sales-and-marketing.param',
    defaultMessage: 'sales-and-marketing',
  },
  'jobs.category.sales-and-marketing.label': {
    id: 'jobs.category.sales-and-marketing.label',
    defaultMessage: 'Sales & Marketing',
  },
  'jobs.category.sales-and-marketing.description': {
    id: 'jobs.category.sales-and-marketing.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for sales and marketing jobs in the fashion industry?',
  },
  'jobs.category.sales-and-marketing.introduction': {
    id: 'jobs.category.sales-and-marketing.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for sales & marketing jobs in fashion? Start your new commercial fashion life here.',
  },
  'jobs.category.sales-and-marketing.title': {
    id: 'jobs.category.sales-and-marketing.title',
    defaultMessage: 'Sales & marketing jobs in fashion',
  },
  'jobs.relatedTo': {
    id: 'jobs.relatedTo',
    defaultMessage: '{term} jobs',
  },
  'jobs.company.title': {
    id: 'jobs.company.title',
    defaultMessage: '{company} jobs',
  },
  'jobs.company.description': {
    id: 'jobs.company.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Dreaming about finding a job at {company}? Click here to find the latest {company} jobs you can apply for',
  },
  'jobs.city.title': {
    id: 'jobs.city.title',
    defaultMessage: 'Fashion jobs {city}',
  },
  'jobs.city.description': {
    id: 'jobs.city.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Find your fashion job in {city} with FashionUnited, the international fashion job board.',
  },
  'jobs.city.introduction': {
    id: 'jobs.city.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'Find the fashion job of your dreams in {city} thanks to FashionUnited. More than 10\'000 career opportunities in various fields',
  },
  'jobs.error.notFound.introduction': {
    id: 'jobs.error.notFound.introduction',
    defaultMessage: 'Please have a look below to find your new dream job',
  },
  'jobs.error.notFound.title': {
    id: 'jobs.error.notFound.title',
    defaultMessage: 'The job you were looking for has already been filled',
  },
  'jobs.position.title': {
    id: 'jobs.position.title',
    defaultMessage: '{position} jobs in fashion',
  },
  'jobs.position.description': {
    id: 'jobs.position.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for a job position in fashion? Check the FashionUnited job board and find job openings for most the popular positions in fashion.',
  },
  'jobs.position.introduction': {
    id: 'jobs.position.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'More than 10.000 career opportunities within the different fields of the fashion industry in the FashionUnited network.',
  },
  'jobs.no_jobs_found_criteria': {
    id: 'jobs.no_jobs_found_criteria',
    defaultMessage: 'No jobs found matching this criteria!!',
  },
  'jobs.no_jobs_for_keywords': {
    id: 'jobs.no_jobs_for_keywords',
    defaultMessage: 'Your search {keywords} did not match any of the jobs.',
  },
  location: {
    id: 'location',
    defaultMessage: 'Location',
  },
  oops: {
    id: 'oops',
    defaultMessage: 'Oops!',
  },
  openInNew: {
    id: 'openInNew',
    defaultMessage: 'Open in new window',
  },
  news: {
    id: 'news',
    defaultMessage: 'News',
  },
  'news-feed': {
    id: 'news-feed',
    defaultMessage: 'Just In',
  },
  press: {
    id: 'press',
    defaultMessage: 'Press',
  },
  jobs: {
    id: 'jobs',
    defaultMessage: 'Jobs',
  },
  positions: {
    id: 'positions',
    defaultMessage: 'Positions',
  },
  jobPosition: {
    id: 'jobPosition',
    defaultMessage: 'Job position',
  },
  'jobs-positions.jobs': {
    id: 'jobs-positions.jobs',
    defaultMessage: '{position} jobs',
  },
  numberOfJobs: {
    id: 'numberOfJobs',
    defaultMessage: 'Number of jobs',
  },
  positionsInFashion: {
    id: 'positionsInFashion',
    defaultMessage: 'Positions in Fashion',
  },
  'jobs-positions.title': {
    id: 'jobs-positions.title',
    // eslint-disable-next-line max-len
    defaultMessage: 'List of job openings for the most popular positions in fashion',
  },
  'jobs-positions.introduction': {
    id: 'jobs-positions.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'More than 10.000 career opportunities within the different fields of the fashion industry in the FashionUnited network.',
  },
  'jobs-positions.description': {
    id: 'jobs-positions.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Looking for a job position in fashion? Check the FashionUnited job board and find job openings for most the popular positions in fashion.',
  },
  cities: {
    id: 'cities',
    defaultMessage: 'Cities',
  },
  'jobs-cities.jobs': {
    id: 'jobs-cities.jobs',
    defaultMessage: '{city} jobs',
  },
  'jobs-cities.title': {
    id: 'jobs-cities.title',
    defaultMessage: 'Fashion jobs in the world\'s biggest cities',
  },
  'jobs-cities.introduction': {
    id: 'jobs-cities.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'More than 10.000 career opportunities in the FashionUnited network.',
  },
  'jobs-cities.description': {
    id: 'jobs-cities.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Browse through more than 10.000 career opportunities in the world\'s biggest cities.',
  },
  workAt: {
    id: 'workAt',
    defaultMessage: 'Work-at',
  },
  company: {
    id: 'company',
    defaultMessage: 'Company',
  },
  companies: {
    id: 'companies',
    defaultMessage: 'Companies',
  },
  'company-profile.contactDetails': {
    id: 'company-profile.contactDetails',
    defaultMessage: 'Contact details',
  },
  'company-profile.websiteUrl': {
    id: 'company-profile.websiteUrl',
    defaultMessage: 'Website url',
  },
  'company-profile.videoUrl': {
    id: 'company-profile.videoUrl',
    defaultMessage: 'Video url',
  },
  'company-profile.about': {
    id: 'company-profile.about',
    defaultMessage: 'Text 1 about',
  },
  'company-profile.b2bPartnerPolicy': {
    id: 'company-profile.b2bPartnerPolicy',
    defaultMessage: 'Text 2 about & contact wholesale details',
  },
  'company-profile.desktopHeaderImage': {
    id: 'company-profile.desktopHeaderImage',
    defaultMessage: 'Desktop Header Image',
  },
  'company-profile.mobileHeaderImage': {
    id: 'company-profile.mobileHeaderImage',
    defaultMessage: 'Mobile Header Image',
  },
  'company-profile.saveProfile': {
    id: 'company-profile.saveProfile',
    defaultMessage: 'Save Profile',
  },
  'company-profile.title': {
    id: 'company-profile.title',
    defaultMessage: '{title} wholesale collection',
  },
  'company-profile.description': {
    id: 'company-profile.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Get all {title} wholesale information on the {title} wholesale collection page here',
  },
  'company-profiles.title': {
    id: 'company-profiles.title',
    defaultMessage: "Jobs in the world's biggest fashion companies",
  },
  'company-profiles.description': {
    id: 'company-profiles.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Dreaming about a career in fashion? More than 10.000 career opportunities are waiting for you on FashionUnited.',
  },
  'company-profiles.introduction': {
    id: 'company-profiles.introduction',
    // eslint-disable-next-line max-len
    defaultMessage: 'More than 10.000 career opportunities in the FashionUnited network.',
  },
  'company-profiles.jobs': {
    id: 'company-profiles.jobs',
    defaultMessage: '{company} jobs and careers',
  },
  'fashion-finder.title': {
    id: 'fashion-finder.title',
    defaultMessage: 'Fashion Finder',
  },
  'fashion-finder.description': {
    id: 'fashion-finder.description',
    defaultMessage: 'Fashion Finder',
  },
  'fashion-finder-profile.title': {
    id: 'fashion-finder-profile.title',
    defaultMessage: '{brandName} Fashion Finder',
  },
  'fashion-finder-profile.description': {
    id: 'fashion-finder-profile.description',
    defaultMessage: '{brandName} Fashion Finder',
  },
  'jobs.href': {
    id: 'jobs.href',
    defaultMessage: '/fashionjobs',
  },
  events: {
    id: 'events',
    defaultMessage: 'events',
  },
  special: {
    id: 'special',
    defaultMessage: 'Special',
  },
  ss20Title: {
    id: 'ss20Title',
    defaultMessage: 'Spring Summer 2020 fashion trends',
  },
  ss20MetaDescription: {
    id: 'ss20MetaDescription',
    defaultMessage: 'Discover the latest spring summer 2020 fashion trends.',
  },
  data: {
    id: 'data',
    defaultMessage: 'data',
  },
  trends: {
    id: 'trends',
    defaultMessage: 'trends',
  },
  'fashion-week-web': {
    id: 'fashion-week-web',
    defaultMessage: 'Fashion Week Web',
  },
  'fashion-week-web.title': {
    id: 'fashion-week-web.title',
    // eslint-disable-next-line max-len
    defaultMessage: 'Fashion Week New York, Paris, London, Milan, Berlin on Fashion Week Web and many more',
  },
  'fashion-week-web.metaDescription': {
    id: 'fashion-week-web.metaDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'Fashion Week New York, Paris, London, Milan and many more Fashion Weeks from around the world overview by FashionUnited',
  },
  'fashion-week-web.intro': {
    id: 'fashion-week-web.intro',
    defaultMessage: 'Latest Fashion Week News',
  },
  'fashion-week-web.description': {
    id: 'fashion-week-web.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Fashion Week Web is an overview of Fashion Weeks around the globe including news, images and video\'s.',
  },
  newsletter: {
    id: 'newsletter',
    defaultMessage: 'newsletter',
  },
  'newsletter.href': {
    id: 'newsletter.href',
    defaultMessage: '/newsletter/subscribe',
  },
  'newsletterCategory.href': {
    id: 'newsletterCategory.href',
    defaultMessage: '/newsletter/{category}/subscribe',
  },
  'search.href': {
    id: 'search.href',
    defaultMessage: '/search',
  },
  lookbook: {
    id: 'lookbook',
    defaultMessage: 'lookbook',
  },
  careerInFashion: {
    id: 'careerInFashion',
    defaultMessage: 'Career in Fashion',
  },
  connect: {
    id: 'connect',
    defaultMessage: 'Connect',
  },
  about: {
    id: 'about',
    defaultMessage: 'About',
  },
  fashionNews: {
    id: 'fashionNews',
    defaultMessage: 'Fashion news',
  },
  fashionRetail: {
    id: 'fashionRetail',
    defaultMessage: 'Fashion retail',
  },
  fashionBusiness: {
    id: 'fashionBusiness',
    defaultMessage: 'Fashion business',
  },
  cultureNews: {
    id: 'cultureNews',
    defaultMessage: 'Culture News',
  },
  fashionPeople: {
    id: 'fashionPeople',
    defaultMessage: 'Fashion people',
  },
  fashionShow: {
    id: 'fashionShow',
    defaultMessage: 'Fashion show',
  },
  fashionStatistics: {
    id: 'fashionStatistics',
    defaultMessage: 'Fashion statistics',
  },
  'fashionStatistics.href': {
    id: 'fashionStatistics.href',
    defaultMessage: '/global-fashion-industry-statistics',
  },
  educationNews: {
    id: 'educationNews',
    defaultMessage: 'Education',
  },
  executiveNews: {
    id: 'executiveNews',
    defaultMessage: 'Executive',
  },
  findAFashionJob: {
    id: 'findAFashionJob',
    defaultMessage: 'Find a fashion job',
  },
  'findAFashionJob.href': {
    id: 'findAFashionJob.href',
    defaultMessage: '/fashion-jobs',
  },
  statistics: {
    id: 'statistics',
    defaultMessage: 'Statistics',
  },
  'statistics.href': {
    id: 'statistics.href',
    defaultMessage: 'https://fashionunited.com/global-fashion-industry-statistics',
  },
  businessData: {
    id: 'businessData',
    defaultMessage: 'Business Data',
  },
  'businessData.href': {
    id: 'businessData.href',
    defaultMessage: 'https://fashionunited.com/i',
  },
  discoverEmployers: {
    id: 'discoverEmployers',
    defaultMessage: 'Discover employers',
  },
  'discoverEmployers.href': {
    id: 'discoverEmployers.href',
    defaultMessage: 'https://fashionunited.com/jobs',
  },
  findAnInternship: {
    id: 'findAnInternship',
    defaultMessage: 'Find an internship',
  },
  'findAnInternship.href': {
    id: 'findAnInternship.href',
    defaultMessage: '/fashion-jobs/internships',
  },
  postAFashionVacancy: {
    id: 'postAFashionVacancy',
    defaultMessage: 'Post a fashion vacancy',
  },
  tradeFairsCalendar: {
    id: 'tradeFairsCalendar',
    defaultMessage: 'Trade Fairs Calendar',
  },
  brandDirectory: {
    id: 'brandDirectory',
    defaultMessage: 'Brand Directory',
  },
  youtube: {
    id: 'youtube',
    defaultMessage: 'Youtube',
  },
  facebook: {
    id: 'facebook',
    defaultMessage: 'Facebook',
  },
  'facebook.href': {
    id: 'facebook.href',
    defaultMessage: 'https://www.facebook.com/FashionUnited',
  },
  linkedin: {
    id: 'linkedin',
    defaultMessage: 'Linkedin',
  },
  instagram: {
    id: 'instagram',
    defaultMessage: 'Instagram',
  },
  fashionUnited: {
    id: 'fashionUnited',
    defaultMessage: 'FashionUnited',
  },
  editorialStatute: {
    id: 'editorialStatute',
    defaultMessage: 'Editorial Statute',
  },
  'editorialStatute.href': {
    id: 'editorialStatute.href',
    defaultMessage: 'https://fashionunited.com/landing/editorial-statute',
  },
  contact: {
    id: 'contact',
    defaultMessage: 'Contact',
  },
  goBack: {
    id: 'goBack',
    defaultMessage: 'Go Back',
  },
  categoryTitle: {
    id: 'categoryTitle',
    defaultMessage: 'Latest Articles in {title}',
  },
  eventsMetaDescription: {
    id: 'eventsMetaDescription',
    /* eslint-disable-next-line max-len */
    defaultMessage: 'Fashion trade shows calendar with fashion events from all around the world. Including business events and Fashion Weeks.',
  },
  eventsTitle: {
    id: 'eventsTitle',
    defaultMessage: 'Fashion trade shows, fairs and apparel events calendar',
  },
  eventsIntro: {
    id: 'eventsIntro',
    /* eslint-disable-next-line max-len */
    defaultMessage: 'Listing of the upcoming fashion industry events such as fashion weeks, trade shows and fairs, for fashion business professionals.',
  },
  indexTitle: {
    id: 'indexTitle',
    /* eslint-disable-next-line max-len */
    defaultMessage: 'Fashion Jobs & Fashion Trade News, Business apparel industry platform',
  },
  indexDescription: {
    id: 'indexDescription',
    /* eslint-disable-next-line max-len */
    defaultMessage: 'Fashion World business platform for the global apparel industry',
  },
  newsFeedTitle: {
    id: 'newsFeedTitle',
    defaultMessage: 'Just In',
  },
  newsFeedPath: {
    id: 'newsFeedPath',
    defaultMessage: 'just-in',
  },
  includePressReleases: {
    id: 'includePressReleases',
    defaultMessage: 'Include Press Releases',
  },
  searchTitle: {
    id: 'searchTitle',
    defaultMessage: 'Search',
  },
  'search.sort.relevanceAndDate': {
    id: 'search.sort.relevanceAndDate',
    defaultMessage: 'Relevance and date (default)',
  },
  'search.sort.relevance': {
    id: 'search.sort.relevance',
    defaultMessage: 'Relevance',
  },
  'search.sort.createdAt': {
    id: 'search.sort.createdAt',
    defaultMessage: 'Date (latest first)',
  },
  'search.sort.createdAtAscending': {
    id: 'search.sort.createdAtAscending',
    defaultMessage: 'Date (oldest first)',
  },
  tagMetaDescription: {
    id: 'tagMetaDescription',
    defaultMessage: 'Latest {title} news and archive',
  },
  tagTitle: {
    id: 'tagTitle',
    defaultMessage: '{title} news and archive',
  },
  tagsMetaDescription: {
    id: 'tagsMetaDescription',
    /* eslint-disable-next-line max-len */
    defaultMessage: 'The independent fashion news platform and article database, including retail news, news on fashion business, culture, fashion people and industry fairs.',
  },
  tagsTitle: {
    id: 'tagsTitle',
    defaultMessage: 'FashionUnited tags',
  },
  trendsIntro: {
    id: 'trendsIntro',
    defaultMessage: 'Latest Fashion Trends',
  },
  trendsMetaDescription: {
    id: 'trendsMetaDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'Fashion jobs and Fashion news including latest trends, design, a job board for the apparel fashion industry and many fashion and shoe brands for designers.',
  },
  trendsNews: {
    id: 'trendsNews',
    defaultMessage: 'Latest Trends News',
  },
  trendsButton: {
    id: 'trendsButton',
    defaultMessage: 'More Trends',
  },
  trendsFeed: {
    id: 'trendsFeed',
    defaultMessage: 'Daily Trend Feed',
  },
  top100: {
    id: 'top100',
    defaultMessage: 'Top 100',
  },
  eventsSearchPlaceholder: {
    id: 'eventsSearchPlaceholder',
    defaultMessage: 'Search events',
  },
  date: {
    id: 'date',
    defaultMessage: 'Date',
  },
  city: {
    id: 'city',
    defaultMessage: 'City',
  },
  prefix: {
    id: 'prefix',
    defaultMessage: '',
  },
  startUrl: {
    id: 'startUrl',
    defaultMessage: '',
  },
  eventsPath: {
    id: 'eventsPath',
    defaultMessage: 'events',
  },
  searchPath: {
    id: 'searchPath',
    defaultMessage: 'search',
  },
  jobsPath: {
    id: 'jobsPath',
    defaultMessage: 'fashion-jobs',
  },
  'jobsApplyPath.suffix': {
    id: 'jobsApplyPath.suffix',
    defaultMessage: 'apply',
  },
  'events.href': {
    id: 'events.href',
    defaultMessage: '/events',
  },
  'news.href': {
    id: 'news.href',
    defaultMessage: 'https://fashionunited.com',
  },
  'trends.href': {
    id: 'trends.href',
    defaultMessage: '/trends',
  },
  jobsMetaDescription: {
    id: 'jobsMetaDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'The most comprehensive and up-to-date fashion job board for the fashion industry.',
  },
  jobsTitle: {
    id: 'jobsTitle',
    defaultMessage: 'Find your fashion job with FashionUnited',
  },
  jobsWfbTitle: {
    id: 'jobsWfbTitle',
    defaultMessage: 'Search by top brands',
  },
  searchJobs: {
    id: 'searchJobs',
    defaultMessage: 'Search for jobs',
  },
  'searchJobs.href': {
    id: 'searchJobs.href',
    defaultMessage: '/fashion-jobs',
  },
  postJob: {
    id: 'postJob',
    defaultMessage: 'Post a job',
  },
  'postJob.href': {
    id: 'postJob.href',
    defaultMessage: 'https://fashionunited.com/company/submit-your-job-postings',
  },
  'jobsHeading.retail': {
    id: 'jobsHeading.retail',
    defaultMessage: 'RETAIL MANAGEMENT & IN-STORE FASHION JOBS',
  },
  'jobsHeading.retail.jobTitles': {
    id: 'jobsHeading.retail.jobTitles',
    // eslint-disable-next-line max-len
    defaultMessage: 'store manager, sales associate, (visual) merchandiser, assistant manager, supervisor',
  },
  'jobsHeading.retail.href': {
    id: 'jobsHeading.retail.href',
    defaultMessage: '/fashion-jobs/retail-management-and-in-store',
  },
  'jobsHeading.sales': {
    id: 'jobsHeading.sales',
    defaultMessage: 'SALES & MARKETING JOBS IN FASHION',
  },
  'jobsHeading.sales.jobTitles': {
    id: 'jobsHeading.sales.jobTitles',
    // eslint-disable-next-line max-len
    defaultMessage: 'account manager, marketing manager, sales manager, e-commerce, merchandising',
  },
  'jobsHeading.sales.href': {
    id: 'jobsHeading.sales.href',
    defaultMessage: '/fashion-jobs/sales-and-marketing',
  },
  'jobsHeading.design': {
    id: 'jobsHeading.design',
    defaultMessage: 'DESIGN & CREATIVE JOBS IN FASHION',
  },
  'jobsHeading.design.jobTitles': {
    id: 'jobsHeading.design.jobTitles',
    // eslint-disable-next-line max-len
    defaultMessage: 'designer, graphic designer, machinist, pattern cutter, stylist',
  },
  'jobsHeading.design.href': {
    id: 'jobsHeading.design.href',
    defaultMessage: '/fashion-jobs/design-and-creative',
  },
  'jobsHeading.product': {
    id: 'jobsHeading.product',
    defaultMessage: 'PRODUCT & SUPPLY CHAIN JOBS IN FASHION',
  },
  'jobsHeading.product.jobTitles': {
    id: 'jobsHeading.product.jobTitles',
    // eslint-disable-next-line max-len
    defaultMessage: 'buyer, production coordinator, quality controller, supply chain manager',
  },
  'jobsHeading.product.href': {
    id: 'jobsHeading.product.href',
    defaultMessage: '/fashion-jobs/fashion-jobs/product-and-supply-chain',
  },
  'jobsHeading.other': {
    id: 'jobsHeading.other',
    defaultMessage: 'OTHER JOBS IN FASHION',
  },
  'jobsHeading.other.jobTitles': {
    id: 'jobsHeading.other.jobTitles',
    // eslint-disable-next-line max-len
    defaultMessage: 'receptionist, accountant, finance manager, editor, office manager, HR manager',
  },
  'jobsHeading.other.href': {
    id: 'jobsHeading.other.href',
    defaultMessage: '/fashion-jobs/other',
  },
  'jobsHeading.internships': {
    id: 'jobsHeading.internships',
    defaultMessage: 'INTERNSHIPS & TRAINEESHIPS',
  },
  'jobsHeading.internships.jobTitles': {
    id: 'jobsHeading.internships.jobTitles',
    // eslint-disable-next-line max-len
    defaultMessage: 'design, product development, marketing, social media, merchandising, editorial',
  },
  'jobsHeading.internships.href': {
    id: 'jobsHeading.internships.href',
    defaultMessage: '/fashion-jobs/internships',
  },
  'jobsHeading.international': {
    id: 'jobsHeading.international',
    defaultMessage: 'INTERNATIONAL JOBS IN FASHION',
  },
  'jobsHeading.international.jobTitles': {
    id: 'jobsHeading.international.jobTitles',
    defaultMessage: 'Search jobs in over 20 countries worldwide',
  },
  'jobsHeading.international.href': {
    id: 'jobsHeading.international.href',
    defaultMessage: 'https://fashionunited.com/landing/international-fashion-jobs',
  },
  'jobsAction.newsletter': {
    id: 'jobsAction.newsletter',
    defaultMessage: 'NEWSLETTER',
  },
  'jobsAction.newsletter.subTitle': {
    id: 'jobsAction.newsletter.subTitle',
    defaultMessage: 'get a free subscription',
  },
  'jobsAction.newsletter.href': {
    id: 'jobsAction.newsletter.href',
    defaultMessage: '/newsletter/subscribe',
  },
  'jobsAction.newsletter.useRouter': {
    id: 'jobsAction.newsletter.useRouter',
    defaultMessage: false,
  },
  'jobsAction.newsletter.route': {
    id: 'jobsAction.newsletter.route',
    defaultMessage: '/newsletter/subscribe',
  },
  'jobsAction.employers': {
    id: 'jobsAction.employers',
    defaultMessage: 'DISCOVER EMPLOYERS IN FASHION',
  },
  'jobsAction.employers.subTitle': {
    id: 'jobsAction.employers.subTitle',
    defaultMessage: 'find your perfect suit',
  },
  'jobsAction.employers.href': {
    id: 'jobsAction.employers.href',
    defaultMessage: '/jobs',
  },
  'jobsAction.employers.useRouter': {
    id: 'jobsAction.employers.useRouter',
    defaultMessage: false,
  },
  'jobsAction.employers.route': {
    id: 'jobsAction.employers.route',
    defaultMessage: '/jobs',
  },
  'jobsAction.education': {
    id: 'jobsAction.education',
    defaultMessage: 'EDUCATION',
  },
  'jobsAction.education.subTitle': {
    id: 'jobsAction.education.subTitle',
    // eslint-disable-next-line max-len
    defaultMessage: 'The Fashion Education Network that bridges the gap between education and the industry',
  },
  'jobsAction.education.href': {
    id: 'jobsAction.education.href',
    defaultMessage: 'https://fashionunited.com/education/courses',
  },
  'jobsAction.education.useRouter': {
    id: 'jobsAction.education.useRouter',
    defaultMessage: false,
  },
  'jobsAction.education.route': {
    id: 'jobsAction.education.route',
    defaultMessage: 'courses',
  },
  careersTitle: {
    id: 'careersTitle',
    defaultMessage: 'Fashion Careers',
  },
  careersMetaDescription: {
    id: 'careersMetaDescription',
    defaultMessage: 'Discover the latest Career fashion trends.',
  },
  fw20Title: {
    id: 'fw20Title',
    defaultMessage: 'Herfst/winter modetrends 2020',
  },
  fw20MetaDescription: {
    id: 'fw20MetaDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'Dit zijn de laatste nieuwtjes over de modetrends van herfst en winter 2020/2021.',
  },
  coronaVirusTitle: {
    id: 'coronaVirusTitle',
    defaultMessage: 'Impact of Covid-19 / Coronavirus on fashion industry',
  },
  coronaVirusDesription: {
    id: 'coronaVirusDesription',
    // eslint-disable-next-line max-len
    defaultMessage: 'On this page FashionUnited publishes the latest updates about Covid-19 / Coronavirus. Please send relevant updates to tip@fashionunited.com. Most positive coronavirus news currently comes from China. CCCT, the Chinese Textile and Apparel chamber of commerce, reports a positive trend in the resumption of operations in textile and apparel sectors. The capacity of production moved towards 80 percent of the normal situation. Logistics and port facilities are recovering. After surfacing in Wuhan late 2019, the draconian measures have worked even in Wuhan, and slowly but surely bring business back to normal. With Italy following China\'s measures effect is expected in the next two weeks. Major apparel production countries, India, Bangladesh, Turkey, Portugal and Morocco are operating at full capacity. Most other countries have taken Covid-19 seriously and are taking precautions to contain the virus to prevent Chinese and Italian scenario\'s.',
  },
  sponsorMessage: {
    id: 'sponsorMessage',
    defaultMessage: 'ADVERTORIAL',
  },
  pressReleaseMessage: {
    id: 'pressReleaseMessage',
    defaultMessage: 'PRESS RELEASE',
  },
  socialMediaTitle: {
    id: 'socialMediaTitle',
    defaultMessage: 'Social Media in Fashion',
  },
  socialMediaDescription: {
    id: 'socialMediaDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'Read all about the many Social Media trends in the fashion industry.',
  },
  fw23Title: {
    id: 'fw23Title',
    defaultMessage: 'Autumn Winter 2023 fashion trends and new collections',
  },
  fw23Description: {
    id: 'fw23Description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Discover the latest autumn winter 2023 fashion trends and the new collections for the season. Many fashion brands have launched their winter 2023 collection, read about them in the trend news below. Various trend forecasters report about the autumn winter 2023 fashion trend forecasts including colors, fabrics, silhouettes, patterns, styles, and more for clothing collections in upcoming seasons. You will find trend information for womenswear, menswear, childrenswear, shoes and accessories.',
  },
  articleBy: {
    id: 'articleBy',
    defaultMessage: 'By {author}',
  },
  allArticlesBy: {
    id: 'allArticlesBy',
    defaultMessage: 'Articles by {author}',
  },
  startupsTitle: {
    id: 'startupsTitle',
    defaultMessage: 'Fashion Startups new technology',
  },
  startupsDescription: {
    id: 'startupsDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'There is a growing need for smart technology in the fashion industry and for new business models. Read all about fashion startups here.',
  },
  cookiesStatement: {
    id: 'cookiesStatement',
    // eslint-disable-next-line max-len
    defaultMessage: 'This site uses cookies to deliver its services, to personalise ads and to analyse traffic. If you continue browsing the site, you agree to ',
  },
  cookieDescriptionLinkText: {
    id: 'cookieDescriptionLinkText',
    defaultMessage: 'our use of cookies',
  },
  learnMore: {
    id: 'learnMore',
    defaultMessage: 'Learn more',
  },
  gotIt: {
    id: 'gotIt',
    defaultMessage: 'Got it',
  },
  'applicantForm.button': {
    id: 'applicantForm.button',
    defaultMessage: 'Submit',
  },
  'applicantForm.disclaimer': {
    id: 'applicantForm.disclaimer',
    defaultMessage: "<small><em>Privacy statement: </em> FashionUnited values your trust in its services and is committed to maintaining that trust and respecting your privacy. FashionUnited ensures that information is gathered for purposes related to FashionUnited services, will only be used by FashionUnited and will not be sold to third parties. When applying for a job, the Company name and country is clearly stated before you send this third party company your information. You may, at any time, contact FashionUnited to view, update, modify or remove your personal information from the FashionUnited database and restrict our processing of it. For more information see the <a href='https://fashionunited.info/privacy'>Privacy Policy</a></small>",
  },
  'applicantForm.title': {
    id: 'applicantForm.title',
    defaultMessage: 'Apply here to become the next',
  },
  'applicantForm.applyButton': {
    id: 'applicantForm.applyButton',
    defaultMessage: 'APPLY HERE',
  },
  'applicantForm.coverLetterLabel': {
    id: 'applicantForm.coverLetterLabel',
    defaultMessage: 'Cover Letter',
  },
  'applicantForm.cvLabel': {
    id: 'applicantForm.cvLabel',
    defaultMessage: 'CV/Resume',
  },
  'applicantForm.extraDocument1Label': {
    id: 'applicantForm.extraDocument1Label',
    defaultMessage: 'Extra Document',
  },
  'applicantForm.extraDocument2Label': {
    id: 'applicantForm.extraDocument2Label',
    defaultMessage: 'Extra Document',
  },
  'applicantForm.subscribedToNewsletterLabel': {
    id: 'applicantForm.subscribedToNewsletterLabel',
    defaultMessage: 'Keep me updated on the latest industry news',
  },
  'applicantForm.allowedFileFormats': {
    id: 'applicantForm.allowedFileFormats',
    defaultMessage:
      '(.pdf, .txt, .doc, .docx, .rtf, .odt, .jpg, .jpeg, .png - 6 MB)',
  },
  'applicantForm.noFileSelected': {
    id: 'applicantForm.noFileSelected',
    defaultMessage: 'No file selected',
  },
  'applicantForm.fieldRequired': {
    id: 'applicantForm.fieldRequired',
    defaultMessage: 'This field is required',
  },
  'applicantForm.fileIsEmpty': {
    id: 'applicantForm.fileIsEmpty',
    defaultMessage: 'File must not be empty',
  },
  'applicantForm.fileHasInvalidType': {
    id: 'applicantForm.fileHasInvalidType',
    defaultMessage: 'File must have valid type',
  },
  'applicantForm.fileMaxSizeExceeded': {
    id: 'applicantForm.fileMaxSizeExceeded',
    defaultMessage: 'File must be less than 6MB',
  },
  'applicantForm.mustBeValidEmailAddress': {
    id: 'applicantForm.mustBeValidEmailAddress',
    defaultMessage: 'This field must be a valid email address',
  },
  'applicantForm.applicationSent': {
    id: 'applicantForm.applicationSent',
    defaultMessage: 'The application has been sent.',
  },
  'applicantForm.backToJobBoard': {
    id: 'applicantForm.backToJobBoard',
    defaultMessage: 'You will now return to the job board.',
  },
  thankYou: {
    id: 'thankYou',
    defaultMessage: 'Thank You',
  },
  'jobView.JobTitle': {
    id: 'jobView.JobTitle',
    defaultMessage: 'Job Title',
  },
  'jobView.category': {
    id: 'jobView.category',
    defaultMessage: 'Category',
  },
  'jobView.companyName': {
    id: 'jobView.companyName',
    defaultMessage: 'Company',
  },
  'jobView.contactEmail': {
    id: 'jobView.contactEmail',
    defaultMessage: 'Contact Email',
  },
  'jobView.contactName': {
    id: 'jobView.contactName',
    defaultMessage: 'Contact Name',
  },
  'jobView.contactPhone': {
    id: 'jobView.contactPhone',
    defaultMessage: 'Phone Number',
  },
  'jobView.countryName': {
    id: 'jobView.countryName',
    defaultMessage: 'Country',
  },
  'jobView.datePost': {
    id: 'jobView.datePost',
    defaultMessage: 'Date Posted',
  },
  'jobView.howToApply': {
    id: 'jobView.howToApply',
    defaultMessage: 'Refer to',
  },
  'jobView.location': {
    id: 'jobView.location',
    defaultMessage: 'Location',
  },
  'archivedJobs.search': {
    id: 'archivedJobs.search',
    defaultMessage: 'Show more jobs',
  },
  'archivedJobs.header': {
    id: 'archivedJobs.header',
    defaultMessage: 'This job is not accepting any more applications',
  },
  'archivedJobs.findSimilar': {
    id: 'archivedJobs.findSimilar',
    defaultMessage: 'Or find similar job opportunities in:',
  },
  apply_button_text: {
    id: 'apply_button_text',
    defaultMessage: 'Apply Here',
  },
  fashionJobs: {
    id: 'fashionJobs',
    defaultMessage: 'Fashion Jobs',
  },
  'jobs.returnToList': {
    id: 'jobs.returnToList',
    defaultMessage: 'Return to Job List',
  },
  educationTitle: {
    id: 'educationTitle',
    defaultMessage: 'Mode opleidingen in Nederland',
  },
  educationMetaDescription: {
    id: 'educationMetaDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'In Nederland zijn diverse mode opleidingen die goed aansluiten bij de activiteiten in de modebranche. Lees hier het laatste nieuws op het gebied van opleidingen in de mode.',
  },
  educationIntro: {
    id: 'educationIntro',
    defaultMessage: 'The Fashion Education Network',
  },
  educationDescription: {
    id: 'educationDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'Connecting education and industry by providing news, internships and directories.',
  },
  educationPageMetaDescription: {
    id: 'educationPageMetaDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'The Fashion Education Network is a non-profit initiative which offers fashion schools and institutes a platform to stimulate  interaction and knowledge.',
  },
  executiveTitle: {
    id: 'executiveTitle',
    // eslint-disable-next-line max-len
    defaultMessage: 'Fashion Executives Network, fashion Industry Management news',
  },
  executiveMetaDescription: {
    id: 'executiveMetaDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'Find the latest Fashion Trade news for Fashion Executives around the world. This platform provides the latest executive industry news and  statistics.',
  },
  executiveIntro: {
    id: 'executiveIntro',
    defaultMessage: 'The Fashion Executives Network',
  },
  executiveDescription: {
    id: 'executiveDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'The most comprehensive provider of market data and analysis.',
  },
  executiveNewsletterDescription: {
    id: 'executiveNewsletterDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'Join the fashion community of entrepreneurs, CEOs, designers, buyers and other fashion professionals already receiving the FashionUnited newsletter.',
  },
  'products.clearResults': {
    id: 'products.clearResults',
    defaultMessage: 'Reset filters',
  },
  'products.seeResults': {
    id: 'products.seeResults',
    defaultMessage: 'See {resultsCount} results',
  },
  'products.showAll': {
    id: 'products.showAll',
    defaultMessage: 'Show all',
  },
  'products.filter': {
    id: 'products.filter',
    defaultMessage: 'Filter',
  },
  'products.sort': {
    id: 'products.sort',
    defaultMessage: 'Sort',
  },
  'products.buyNow': {
    id: 'products.buyNow',
    defaultMessage: 'Buy {retailer}',
  },
  'products.brands': {
    id: 'products.brands',
    defaultMessage: 'Brands',
  },
  'products.department': {
    id: 'products.department',
    defaultMessage: 'Department',
  },
  'products.sizes': {
    id: 'products.sizes',
    defaultMessage: 'Sizes',
  },
  'products.colors': {
    id: 'products.colors',
    defaultMessage: 'Colors',
  },
  'products.seasons': {
    id: 'products.seasons',
    defaultMessage: 'Seasons',
  },
  'products.genders': {
    id: 'products.genders',
    defaultMessage: 'Gender',
  },
  'products.ageGroups': {
    id: 'products.ageGroups',
    defaultMessage: 'Age Group',
  },
  'products.price': {
    id: 'products.price',
    defaultMessage: 'Price',
  },
  'products.orderQuantity': {
    id: 'products.orderQuantity',
    defaultMessage: 'Order Quantity',
  },
  'products.deliveryTime': {
    id: 'products.deliveryTime',
    defaultMessage: 'Delivery Time',
  },
  'products.deliveryTwoWeeks': {
    id: 'products.deliveryTwoWeeks',
    defaultMessage: 'Delivered within 2 weeks',
  },
  'products.deliveryFiveWeeks': {
    id: 'products.deliveryFiveWeeks',
    defaultMessage: 'Delivered within 5 weeks',
  },
  'products.deliveryTwoMonths': {
    id: 'products.deliveryTwoMonths',
    defaultMessage: 'Delivered within 2 months',
  },
  'products.modelImages': {
    id: 'products.modelImages',
    defaultMessage: 'Model photos',
  },
  'products.imageWithModel': {
    id: 'products.imageWithModel',
    defaultMessage: 'Only show products featuring model photos',
  },
  'products.imageWithoutModel': {
    id: 'products.imageWithoutModel',
    defaultMessage: 'Show products having photos without a model',
  },
  'products.prints': {
    id: 'products.prints',
    defaultMessage: 'Prints',
  },
  'products.materials': {
    id: 'products.materials',
    defaultMessage: 'Materials',
  },
  'products.moreBrands': {
    id: 'products.moreBrands',
    defaultMessage: 'More Brands',
  },
  'product.gender': {
    id: 'product.gender',
    defaultMessage: 'Gender',
  },
  'product.ageGroup': {
    id: 'product.ageGroup',
    defaultMessage: 'Age Group',
  },
  'product.orderQuantity': {
    id: 'product.orderQuantity',
    defaultMessage: 'Order Quantity',
  },
  'product.deliveryTime': {
    id: 'product.deliveryTime',
    defaultMessage: 'Delivery Time',
  },
  'product.colors': {
    id: 'product.colors',
    defaultMessage: 'Colors',
  },
  'product.material': {
    id: 'product.material',
    defaultMessage: 'Material',
  },
  'product.season': {
    id: 'product.season',
    defaultMessage: 'Season',
  },
  'product.brandName': {
    id: 'product.brandName',
    defaultMessage: 'Brand name',
  },
  'product.pattern': {
    id: 'product.pattern',
    defaultMessage: 'Pattern',
  },
  'product.colorName': {
    id: 'product.colorName',
    defaultMessage: 'Color name',
  },
  'product.gtin': {
    id: 'product.gtin',
    defaultMessage: 'GTIN',
  },
  'product.ageGroups': {
    id: 'product.ageGroups',
    defaultMessage: 'Age group',
  },
  'product.sizes': {
    id: 'product.sizes',
    defaultMessage: 'Sizes',
  },
  'product.price': {
    id: 'product.price',
    defaultMessage: 'Price',
  },
  'product.shippingCost': {
    id: 'product.shippingCost',
    defaultMessage: 'Shipping cost',
  },
  'product.backToProducts': {
    id: 'product.backToProducts',
    defaultMessage: 'Back to overview',
  },
  'product.buyAt': {
    id: 'product.buyAt',
    defaultMessage: 'Buy at {retailerName}',
  },
  'product.contact': {
    id: 'product.contact',
    defaultMessage: 'Contact Brand',
  },
  continue: {
    id: 'continue',
  },
  'login.continue': {
    id: 'login.continue',
    defaultMessage: 'Continue',
  },
  forgotPassword: {
    id: 'forgotPassword',
    defaultMessage: 'Forgot Password?',
  },
  'login.title': {
    id: 'login.title',
    defaultMessage: 'Log in to FashionUnited to continue',
  },
  login: {
    id: 'login',
    defaultMessage: 'Log In',
  },
  logout: {
    id: 'logout',
    defaultMessage: 'Log out',
  },
  'register.createAccount': {
    id: 'register.createAccount',
    defaultMessage: 'Create Account',
  },
  editProfile: {
    id: 'editProfile',
    defaultMessage: 'Edit Profile',
  },
  requestAccess: {
    id: 'requestAccess',
    defaultMessage: 'Request Access',
  },
  updateProfile: {
    id: 'updateProfile',
    defaultMessage: 'Update Profile',
  },
  profile: {
    id: 'profile',
    defaultMessage: 'Profile',
  },
  'profile.accountDetails': {
    id: 'profile.accountDetails',
    defaultMessage: 'Account Details',
  },
  'profile.memberSince': {
    id: 'profile.memberSince',
    defaultMessage: 'Member since',
  },
  'profile.myCompany': {
    id: 'profile.myCompany',
    defaultMessage: `My {companyCount, plural,
      one {Company}
      other {Companies}
    }`,
  },
  'profile.myMarkets': {
    id: 'profile.myMarkets',
    defaultMessage: 'My Markets',
  },
  marketplace: {
    id: 'marketplace',
    defaultMessage: 'Marketplace',
  },
  'markets.title': {
    id: 'markets.title',
    defaultMessage: 'FashionUnited B2B Marketplace',
  },
  'markets.description': {
    id: 'markets.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'A B2B Marketplace providing apparel buyers with unique trend insights and brand collection overviews.',
  },
  'market.title': {
    id: 'market.title',
    defaultMessage: '{name} - FashionUnited B2B Marketplace',
  },
  'stands.title': {
    id: 'stands.title',
    defaultMessage: '{name} stands - FashionUnited B2B Marketplace',
  },
  'stands.headingTitle': {
    id: 'stands.headingTitle',
    defaultMessage: '{name} stands',
  },
  'stand.title': {
    id: 'stand.title',
    defaultMessage: '{name} @ {marketName} - FashionUnited B2B Marketplace',
  },
  'brands.title': {
    id: 'brands.title',
    defaultMessage: '{name} brands - FashionUnited B2B Marketplace',
  },
  'brands.headingTitle': {
    id: 'brands.headingTitle',
    defaultMessage: '{name} brands',
  },
  'products.market.title': {
    id: 'products.market.title',
    defaultMessage: '{name} products - FashionUnited B2B Marketplace',
  },
  'products.market.headingTitle': {
    id: 'products.market.headingTitle',
    defaultMessage: '{name} products',
  },
  'products.stand.title': {
    id: 'products.stand.title',
    defaultMessage:
      '{name} @ {marketName} products - FashionUnited B2B Marketplace',
  },
  'products.stand.headingTitle': {
    id: 'products.stand.headingTitle',
    defaultMessage: '{name} products',
  },
  products: {
    id: 'products',
    defaultMessage: 'Products',
  },
  brands: {
    id: 'brands',
    defaultMessage: 'Brands',
  },
  stands: {
    id: 'stands',
    defaultMessage: 'Stands',
  },
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  privacy: {
    id: 'privacy',
    defaultMessage: 'Privacy',
  },
  termsOfUse: {
    id: 'termsOfUse',
    defaultMessage: 'Terms of Use',
  },
  signup: {
    id: 'signup',
    defaultMessage: 'Sign Up',
  },
  'register.title': {
    id: 'register.title',
    defaultMessage: 'Register with FashionUnited',
  },
  'register.alreadyRegistered': {
    id: 'register.alreadyRegistered',
    defaultMessage: 'Already have an account?',
  },
  'register.passwordTooShort': {
    id: 'register.passwordTooShort',
    defaultMessage: 'Your password must be at least 12 characters long',
  },
  'register.successHeadline': {
    id: 'register.successHeadline',
    defaultMessage: 'You have successfully registered.',
  },
  'register.successMessage': {
    id: 'register.successMessage',
    // eslint-disable-next-line max-len
    defaultMessage: 'Please check your email inbox to verify your email address.',
  },
  'register.successRedirect': {
    id: 'register.successRedirect',
    defaultMessage: 'You will be redirected to the login page.',
  },
  'register.notABuyer': {
    id: 'register.notABuyer',
    defaultMessage: 'Not affiliated with a company? ',
  },
  'register.basicRegistration': {
    id: 'register.basicRegistration',
    defaultMessage: 'Basic registration',
  },
  'register.emailNotVerified': {
    id: 'register.emailNotVerified',
    // eslint-disable-next-line max-len
    defaultMessage: 'It looks like you haven\'t verified your email yet. Please check your email inbox for further instructions.',
  },
  resendEmail: {
    id: 'resendEmail',
    defaultMessage: 'Resend Email',
  },
  emailResent: {
    id: 'emailResent',
    // eslint-disable-next-line max-len
    defaultMessage: 'Verification email successfully resent. Please check your email inbox to verify your email address.',
  },
  errorRequestingEmail: {
    id: 'errorRequestingEmail',
    // eslint-disable-next-line max-len
    defaultMessage: 'An error has occurred. Please try requesting a verification email again later.',
  },
  register: {
    id: 'register',
    defaultMessage: 'Register',
  },
  resetPassword: {
    id: 'resetPassword',
    defaultMessage: 'Reset Password',
  },
  password: {
    id: 'password',
    defaultMessage: 'Password',
  },
  'resetPassword.title': {
    id: 'resetPassword.title',
    defaultMessage: 'Reset your password',
  },
  'resetPassword.successHeadline': {
    id: 'resetPassword.successHeadline',
    defaultMessage: 'We have received your request.',
  },
  'resetPassword.successMessage': {
    id: 'resetPassword.successMessage',
    defaultMessage: 'Please check your email to reset your password.',
  },
  'resetPassword.mustBeValidEmail': {
    id: 'resetPassword.mustBeValidEmail',
    defaultMessage: 'Must be a valid email address',
  },
  'resetPassword.enterEmail': {
    id: 'resetPassword.enterEmail',
    defaultMessage: 'Enter your email address',
  },
  'resetPassword.returnToLogin': {
    id: 'resetPassword.returnToLogin',
    defaultMessage: 'Return to the login page',
  },
  'resetPassword.sendLink': {
    id: 'resetPassword.sendLink',
    defaultMessage: 'Send Reset Link',
  },
  'changePassword.title': {
    id: 'changePassword.title',
    defaultMessage: 'Change your password',
  },
  'changePassword.newPassword': {
    id: 'changePassword.newPassword',
    defaultMessage: 'Choose a new password',
  },
  'changePassword.successHeadline': {
    id: 'changePassword.successHeadline',
    defaultMessage: 'Success',
  },
  'changePassword.successMessage': {
    id: 'changePassword.successMessage',
    defaultMessage: 'You may now log in with your new password.',
  },
  'changePassword.successRedirect': {
    id: 'changePassword.successRedirect',
    defaultMessage: 'You will be redirected to the login page.',
  },
  mustBeValidUrl: {
    id: 'mustBeValidUrl',
    defaultMessage: 'Please enter a valid url.',
  },
  submit: {
    id: 'submit',
    defaultMessage: 'Submit',
  },
  currencyCode: {
    id: 'currencyCode',
    defaultMessage: 'USD',
  },
  moreProductsAvailable: {
    id: 'moreProductsAvailable',
    defaultMessage: 'There are products that you cannot view.',
  },
  moreProductsAvailableAfterLogin: {
    id: 'moreProductsAvailableAfterLogin',
    // eslint-disable-next-line max-len
    defaultMessage: 'There are products that you cannot view because you are not logged in.',
  },
  moreProductsAvailableAfterUpdate: {
    id: 'moreProductsAvailableAfterUpdate',
    // eslint-disable-next-line max-len
    defaultMessage: 'There are products that you cannot view. To request buyer access you must first complete your user profile, then use the request access button.',
  },
  moreProductsAvailableSuccess: {
    id: 'moreProductsAvailableSuccess',
    // eslint-disable-next-line max-len
    defaultMessage: 'We have successfully received your access request. A FashionUnited employee will check your application. You will receive an email within the next few days when your request is approved.',
  },
  moreProductsAvailablePending: {
    id: 'moreProductsAvailablePending',
    // eslint-disable-next-line max-len
    defaultMessage: 'Your access request is currently under review. You will receive an email within the next few days when your request is approved.',
  },
  completeBuyerProfile: {
    id: 'completeBuyerProfile',
    // eslint-disable-next-line max-len
    defaultMessage: 'Fill in the missing fields below to complete your Marketplace buyer account.',
  },
  errorWhileRequestingAccess: {
    id: 'errorWhileRequestingAccess',
    defaultMessage: 'Error while requesting access!',
  },
  education: {
    id: 'education',
    defaultMessage: 'Education',
  },
  executive: {
    id: 'executive',
    defaultMessage: 'Executive',
  },
  rss: {
    id: 'rss',
    defaultMessage: 'RSS',
  },
  rssFeed: {
    id: 'rssFeed',
    defaultMessage: 'RSS Feed',
  },
  ethics: {
    id: 'ethics',
    defaultMessage: 'Ethics',
  },
  loading: {
    id: 'loading',
    defaultMessage: 'loading...',
  },
  searchLabel: {
    id: 'searchLabel',
    defaultMessage: 'Search {pageTitle}',
  },
  'brands-directory.title': {
    id: 'brands-directory.title',
    defaultMessage: 'International Fashion Brands Directory',
  },
  'brands-directory.description': {
    id: 'brands-directory.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'The global fashion brand directory with thousands of carefully selected apparel brands listed per category.',
  },
  'brands-directory.all-countries.label': {
    id: 'brands-directory.all-countries.label',
    defaultMessage: 'All Countries',
  },
  'brands-directory-with-industry.title': {
    id: 'brands-directory-with-industry.title',
    defaultMessage: '{industries} Brands Directory',
  },
  'company-profile-products.title': {
    id: 'company-profile-products.title',
    defaultMessage: '{title} wholesale collection products',
  },
  'company-profile.editProfile': {
    id: 'company-profile.editProfile',
    defaultMessage: 'Edit Profile',
  },
  firstName: {
    id: 'firstName',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'lastName',
    defaultMessage: 'Last name',
  },
  name: {
    id: 'name',
    defaultMessage: 'Name',
  },
  emailAddress: {
    id: 'emailAddress',
    defaultMessage: 'Email address',
  },
  country: {
    id: 'country',
    defaultMessage: 'Country',
  },
  language: {
    id: 'language',
    defaultMessage: 'Language',
  },
  companyName: {
    id: 'companyName',
    defaultMessage: 'Company name',
  },
  website: {
    id: 'website',
    defaultMessage: 'Website',
  },
  websiteUrl: {
    id: 'websiteUrl',
    defaultMessage: 'Website URL',
  },
  chamberOfCommerce: {
    id: 'chamberOfCommerce',
    defaultMessage: 'Chamber of Commerce',
  },
  chamberOfCommerceNumber: {
    id: 'chamberOfCommerceNumber',
    defaultMessage: 'Chamber of Commerce number',
  },
  edit: {
    id: 'edit',
    defaultMessage: 'Edit',
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
  },
  'edit-user-profile.title': {
    id: 'edit-user-profile.title',
    defaultMessage: 'Edit your profile',
  },
  'company-profile-edit.title': {
    id: 'company-profile-edit.title',
    defaultMessage: 'Edit {title}',
  },
  relatedProducts: {
    id: 'relatedProducts',
    defaultMessage: 'Related Products',
  },
  buyNow: {
    id: 'buyNow',
    defaultMessage: 'Buy now',
  },
  'companies-directory.title': {
    id: 'companies-directory.title',
    defaultMessage: 'Fashion Company Directory',
  },
  'companies-directory.description': {
    id: 'companies-directory.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'The Fashion Company Directory gathers information of the top fashion companies. Bringing the latest news, jobs offers and stock information on one page.',
  },
  'schools-directory.title': {
    id: 'schools-directory.title',
    defaultMessage: 'Fashion School Directory',
  },
  'schools-directory.description': {
    id: 'schools-directory.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'Find fashion schools and courses in the international Fashion School Database. Browse through more than 500 courses in fashion from over 70 fashion schools.',
  },
  'federations-directory.title': {
    id: 'federations-directory.title',
    defaultMessage: 'Fashion Federations Directory',
  },
  'federations-directory.description': {
    id: 'federations-directory.description',
    // eslint-disable-next-line max-len
    defaultMessage: 'An overview of federations and associations in the fashion industry',
  },
  'manufacturer-directory.title': {
    id: 'manufacturer-directory.title',
    defaultMessage: 'Manufacturer Directory',
  },
  'manufacturer-directory.description': {
    id: 'manufacturer-directory.description',
    defaultMessage: 'Manufacturer directory',
  },
  'software-suppliers-directory.title': {
    id: 'software-suppliers-directory.title',
    defaultMessage: 'Software suppliers Directory',
  },
  'software-suppliers-directory.description': {
    id: 'software-suppliers-directory.description',
    defaultMessage: 'Software suppliers directory',
  },
  'agency-directory.title': {
    id: 'agency-directory.title',
    defaultMessage: 'Agency Directory',
  },
  'agency-directory.description': {
    id: 'agency-directory.description',
    defaultMessage: 'Agency Directory',
  },
  'retail-directory.title': {
    id: 'retail-directory.title',
    defaultMessage: 'Retail Directory',
  },
  'retail-directory.description': {
    id: 'retail-directory.description',
    defaultMessage: 'Retail directory',
  },
  'fashionweeks-directory.title': {
    id: 'fashionweeks-directory.title',
    defaultMessage: 'Fashion Weeks Directory',
  },
  'fashionweeks-directory.description': {
    id: 'fashionweeks-directory.description',
    defaultMessage: 'Fashion Weeks directory',
  },
  sorting: {
    id: 'sorting',
    defaultMessage: 'Sorting',
  },
  latest: {
    id: 'latest',
    defaultMessage: 'Latest',
  },
  alphabetical: {
    id: 'alphabetical',
    defaultMessage: 'Alphabetical',
  },
  favorites: {
    id: 'favorites',
    defaultMessage: 'Favorites',
  },
  emailSuggestion: {
    id: 'emailSuggestion',
    defaultMessage: 'Did you mean {email}?',
  },
  all: {
    id: 'all',
    defaultMessage: 'All',
  },
  'cookieConsent.title': {
    id: 'cookieConsent.title',
    defaultMessage: 'This site uses cookies',
  },
  'cookieConsent.grant': {
    id: 'cookieConsent.grant',
    defaultMessage: 'Accept all',
  },
  'cookieConsent.deny': {
    id: 'cookieConsent.deny',
    defaultMessage: 'Accept functional',
  },
  'cookieConsent.general.message': {
    id: 'cookieConsent.general.message',
    // eslint-disable-next-line max-len
    defaultMessage: '<p><strong>Your data. Your experience.</strong></p><p>This site uses cookies to deliver its services, to personalise ads and to analyse traffic. Your data will be processed and information from your device (cookies, unique identifiers and other device data) may be stored by, accessed by and shared with partners, or used specifically by this site.</p><p>By clicking "Accept all" you agree that FashionUnited and/or partners will store and/or access information on your device through the use of cookies and similar technologies and process your personal data, to display personalised ads and content, for ad and content measurement, audience insights and product development.</p>',
  },
  'cookieConsent.general.title': {
    id: 'cookieConsent.general.title',
    defaultMessage: 'General',
  },
  'cookieConsent.cookies.message': {
    id: 'cookieConsent.cookies.message',
    defaultMessage: '<h2 id="how-fashionunited-uses-cookies">How FashionUnited uses cookies</h2><p>A cookie is a small piece of text sent to your browser by a website you visit. It helps the website to remember information about your visit, like your preferred language and other settings. That can make your next visit easier and the site more useful to you. Cookies play an important role. Without them, using the web would be a much more frustrating experience.</p><p>We use cookies for many purposes. We use them, for example, to remember your safe search preferences, to make the ads you see more relevant to you, to count how many visitors we receive to a page, to help you sign up for our services and to protect your data.</p><p>You can see a list of the types of cookies used by FashionUnited and also find out how FashionUnited and our partners use cookies in advertising. Our <a target="_blank" rel="noreferrer noopener" href="/privacy">privacy policy</a> explains how we protect your privacy in our use of cookies and other information.</p><h3 id="store-and--or-open-information-on-a-device">Store and / or open information on a device</h3><p>Store and / or open information on a device,  like cookies and device identifiers presented to a user.</p><ul><li><a target="_blank" rel="noreferrer noopener" href="https://www.cloudflare.com/privacypolicy/">Cloudflare</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.fastly.com/privacy/">Fastly</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.thinglink.com/privacy">Thinglink</a></li><li>Albumizr</li><li><a target="_blank" rel="noreferrer noopener" href="https://timeline.knightlab.com/docs/faq.html">Knightlab</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://policies.google.com/privacy">Google MyMaps</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.anp.nl/disclaimer-en-privacy-statement-anp">LocalFocus (ANP)</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://apester.com/privacy-policy/">Apester</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://jsfiddle.net/privacy">JSFiddle</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://blog.codepen.io/documentation/privacy-policy/">Codepen.io</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://infogram.com/privacy">Infogram</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.typeform.com/help/a/security-privacy-standards-at-typeform-9350912237844/">Typeform</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://genial.ly/privacy/">Genial.ly</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://h5p.org/privacy">H5P</a></li></ul><h3 id="functional-and-statistical">Functional and statistical</h3><ul><li><a target="_blank" rel="noreferrer noopener" href="https://policies.google.com/privacy">Google Analytics</a></li></ul><h3 id="marketing">Marketing</h3><p>We use cookies and your profile for our own marketing goals. That way you are able to see ads for our products and services on other websites and apps.</p><ul><li><a target="_blank" rel="noreferrer noopener" href="https://policies.google.com/technologies/partner-sites">Google Advertising Products</a></li></ul><h3 id="social-media">Social Media</h3><p>When we integrate content from Facebook, Instagram or Soundcloud in our articles, cookies from these parties are placed to get to know more about your web surfing habits.</p><ul><li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&amp;entry=0">Facebook</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.instagram.com/privacy/checks/?cookie_consent=1&amp;next=https%3A%2F%2Fprivacycenter.instagram.com%2Fpolicy%2F%3Fentry_point%3Dig_help_center_data_policy_redirect%26__coig_consent%3D1">Instagram</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.snap.com/en-GB/privacy/privacy-policy">SnapChat</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://soundcloud.com/pages/privacy">Soundcloud</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.spotify.com/us/privacy">Spotify AB</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/en/privacy">Twitter, Inc</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://vimeo.com/privacy">Vimeo</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.youtube.com/howyoutubeworks/our-commitments/protecting-user-data/">Youtube</a></li></ul><h3 id="advertising">Advertising</h3><p>Advertising keeps FashionUnited and many of the websites and services you use free of charge. We work hard to make sure that ads are safe, unobtrusive and as relevant as possible. For example, you won’t see pop-up ads on FashionUnited nor ads containing malware, ads for counterfeit goods or those that attempt to misuse your personal information.</p><p>FashionUnited uses Google Advertising Services to manage its advertising.</p><h2 id="how-fashionunited-uses-cookies-in-advertising">How FashionUnited uses cookies in advertising</h2><p>Cookies help to make advertising more effective. Without cookies, it’s harder for an advertiser to reach its audience, or to know how many ads were shown and how many clicks they received.</p><p>Many websites, such as news sites and blogs, partner with FashionUnited to show ads to their visitors. Working with our partners, we may use cookies for a number of purposes, such as to stop you from seeing the same ad over and over again, to detect and stop click fraud, and to show ads that are likely to be more relevant (such as ads based on websites you have visited).</p><p>We store a record of the ads we serve in our logs. These server logs typically include your web request, IP address, browser type, browser language, the date and time of your request, and one or more cookies that may uniquely identify your browser. We store this data for a number of reasons, the most important of which are to improve our services and to maintain the security of our systems. We anonymize this log data by removing part of the IP address (after 9 months) and cookie information (after 18 months).</p><h2 id="our-advertising-cookies">Our advertising cookies</h2><p>To help our partners manage their advertising and websites, we offer many products, including AdSense, AdWords, FashionUnited Analytics, and a range of Google-branded services. When you visit a page that uses one of these products, either on one of FashionUnited’s sites or one of our partners’, various cookies may be sent to your browser.</p><p>These may be set from a few different domains, including al sorts of FashionUnited. domains, doubleclick.net, invitemedia.com, admeld.com, Googlesyndication.com, or Googleadservices.com. Some of our advertising products enable our partners to use other services in conjunction with ours (like an ad measurement and reporting service) and these services may send their own cookies to your browser. These cookies will be set from their domains.</p><p>See more detail about the types of cookie used by FashionUnited and our partners, and how we use them.</p><ul><li><a target="_blank" rel="noreferrer noopener" href="https://support.google.com/adspolicy/answer/54817?hl=en">Ad Manager/AdX</a>  </li><li><a target="_blank" rel="noreferrer noopener" href="https://support.google.com/admob/answer/6128543?hl=en">AdMob</a>  </li><li><a target="_blank" rel="noreferrer noopener" href="https://support.google.com/adsense/answer/10961370?hl=en">AdSense</a>  </li><li><a target="_blank" rel="noreferrer noopener" href="https://about.ads.microsoft.com/en-gb/resources/policies/microsoft-advertising-privacy-policy">Microsoft Advertising</a>  </li><li><a target="_blank" rel="noreferrer noopener" href="https://www.hotjar.com/legal/policies/privacy/">Hotjar</a>  </li><li><a target="_blank" rel="noreferrer noopener" href="https://mailchimp.com/legal/">Mailchimp</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://policies.google.com/privacy?hl=en-US">Google</a></li><li><a target="_blank" rel="noreferrer noopener" href="http://corp.aarki.com/privacy">Aarki</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://adacado.com/privacy-policy/">Adacado</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://adara.com/company/privacy-promise/">Adara Media</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://adex.com/cookies">ADEX</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://site.adform.com/privacy-center/website-privacy/website-cookie-policy/">Adform</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.adikteev.com/privacy">Adikteev</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.adledger.org/privacy-policy">AdLedge</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://adloox.com/en/disclaimer">Adloox</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.adludio.com/termsandconditions?topic=1#terms">Adludio</a></li><li><a target="_blank" rel="noreferrer noopener" href="http://www.admaxim.com/admaxim-privacy-policy/">AdMaxim</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://admedo.com/privacy-policy">Admedo</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.admetrics.io/shopify/privacy_policy/">Admetrics</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.adobe.com/be_en/privacy.html">Adobe Advertising Cloud</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.adtriba.com/privacy-policy">AdTriba</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.advanced-store.com/en/data-privacy/">advanced STORE GmbH</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.adventori.com/with-us/platform-privacy-policy/">Adventori</a></li><li>advolution.control</li><li><a target="_blank" rel="noreferrer noopener" href="https://www.akamai.com/legal/compliance/privacy-trust-center">Akamai</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.amazon.nl/gp/help/customer/display.html?nodeId=201909010&amp;ref_=footer_privacy">Amazon</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://cookiepedia.co.uk/giving-consent-to-cookies">Amobee</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://analights.com/docs/analights-privacy-policy-en.pdf">Analights</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.applovin.com/privacy/">AppLovin Corp.</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://monetize.xandr.com/privacy-center/">AppNexus (Xandr) Inc</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.arrivalist.com/privacy/">Arrivalist</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://asklocala.com/privacy-policy/">Ask Locala (F.K.A Fusio by S4M)</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://privacy.audienceproject.com/en-GB/for-clients/privacy-policy?_gl=1*v935h8*_ga*OTExMzQ1MDMuMTY2ODE3NTM1Ng..*_ga_NC5YHF857R*MTY2ODE3NTM1Ni4xLjEuMTY2ODE3NTM3OC4wLjAuMA..">AudienceProject</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://aunica.com/en/privacy-policy/">Aunica</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.avocetltd.co.uk/privacy-policy/">Avocet</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.avocetltd.co.uk/privacy-policy/">Bannerflow</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.basistechnologies.com/privacy-policy/">Basis Technologies</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://batch.com/privacy-policy">Batch Media</a></li><li>BDSK Handels GmbH &amp; Co. KG</li><li><a target="_blank" rel="noreferrer noopener" href="https://www.beeswax.nl/av">Beeswax</a></li><li>Betgenius</li><li><a target="_blank" rel="noreferrer noopener" href="https://www.blis.com/pdfs/Blis-Privacy-policy-2017.pdf">Blismedia</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://bombora.com/privacy-policy/">Bombora</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.booking.com/content/privacy.html?aid=318615;gclid=EAIaIQobChMI5q7Cxamm-wIVe4ODBx0ZRgTJEAAYASAAEgL7MPD_BwE;auth_success=1;ws=;label=New_English_EN_NL_21458573305-EgkQ296H0a6RQX8W38Fy7AS217273644680%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atidsa-55482331735%3Alp9050778%3Ali%3Adec%3Adm">Booking.com</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.c3metrics.com/privacy-policy">C3 Metrics</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://cablato.com/privacy-policy/">Cablato</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://celtra.com/privacy-policy/">Celtra</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.cint.com/participant-privacy-notice">Cint</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://clinch.co/privacy-policy/">Clinch</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.cloudtechnologies.pl/en/privacy-policy">Cloud Technologies</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.cloudflare.com/privacypolicy/">Cloudflare</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.commandersact.com/en/privacy/">Commanders Act</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.commandersact.com/en/privacy/">comScore</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.crimtan.com/privacy-ctl/">Crimtan</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.criteo.com/privacy/">Criteo</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.cubic.com/privacy-policy">CUBED</a></li><li>DataXu</li><li><a target="_blank" rel="noreferrer noopener" href="https://www.demandbase.com/security-policy/">Demandbase</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.dentsu.com/us/en/privacy-policy">DENTSU</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.dentsu.com/us/en/privacy-policy">Dentsu Aegis Network</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://digiseg.io/wp-content/uploads/2020/03/ebook2.3.pdf">Digiseg</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.dmalondon.com/privacy-policy">DMA Institute</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://doubleverify.com/privacy-notice/">DoubleVerify</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://dstillery.com/privacy-policy/">Dstillery</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.dynata.com/privacy-policy-us/">Dynata</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.easymediame.com/">EASYmedia</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.ebay.com/help/policies/member-behaviour-policies/user-privacy-notice-privacy-policy?id=4260">eBay</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.ebuildersgroup.com/privacy-policy">ebuilders</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://effinitysolutions.com/privacy-policy/">Effinity</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.emetriq.com/datenschutz/">emetriq</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.ensighten.com/privacy-policy/">Ensighten</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.epsilontec.com/en/privacy-policy/">Epsilon</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://esseninternational.com/privacy-policy/">Essens</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.evidon.com/opting-out/">Evidon</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://exactag.com/privacy-policy/">Exactag</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://exponential.eu/privacy-policy/">Exponential</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&amp;entry=0">Facebook</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.flashtalking.com/privacypolicy/">Flashtalking by Mediaocean</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.fractionalmedia.com/privacy-policy">Fractional Media</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.gemius.com/cookie-policy.html">Gemius</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://help.sensic.net/privacypolicy_en.html">GfK</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.gsi-one.org/de/privacy-policy.html">GP One</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.groupm.com/privacy-notice/">GroupM</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://createjs.com/legal/privacy.html">gskinner</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://haensel-ams.com/privacy-statement-us/">Haensel AMS</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.havasgroup.com/data-protection-policy/">Havas Media France - DBi</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://privacy.hurra.com/">hurra.com</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.ibm.com/trust/privacy">IBM</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://zetaglobal.com/ignitionone-zetaglobal-partnership-eu.html">Ignition One</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://impact.com/privacy-policy/">Impact</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://improvedigital.com/platform-privacy-policy/">Improve Digital</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.indexexchange.com/privacy/">Index Exchange</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.innovid.com/privacy-policy/">Innovid</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://integralads.com/ias-privacy-data-management/policies/">Integral Ad Science</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.intelliad.com/data-protection/">intelliAd</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.iponweb.com/privacy-policy/">IPONWEB</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://jivox.com/privacy/">Jivox</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.kantar.com/cookies-policies">Kantar</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.kochava.com/support-privacy/">Kochava</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://lifestreet.com/privacy/">LifeStreet</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://liftoff.network/privacy-policy/">Liftoff</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://liveramp.fr/iab-transparency-consent-framework/">LiveRamp</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.localsensor.com/privacy.html">Localsensor</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://legal.loopme.com/privacy-center">LoopMe</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.lotame.com/about-lotame/privacy/lotames-products-services-privacy-policy/">Lotame</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://group.macromill.com/privacy.html">Macromill group</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.magnite.com/legal/advertising-technology-privacy-policy/">Magnite</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.mainad.com/privacy-policy/">MainADV</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.criteo.com/">Manage.com</a></li><li><a target="_blank" rel="noreferrer noopener" href="http://mktsci.com/privacy_policy.htm">Marketing Science Consulting Group, Inc.</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.mediamath.com/privacy-policy/">MediaMath</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.meetrics.com/en/data-privacy/">Meetrics</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.mindtake.com/en/reppublika-privacy-policy">MindTake Research</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.mobitrans.net/privacy-policy/">Mobitrans</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://mobpro.com/privacy.html">Mobpro</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.moloco.com/privacy-policy">Moloco Ads</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://site.msi-aci.com/Home/FlexTrackPrivacy">MSI-ACI</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.nanointeractive.com/brand-safety-policy/">Nano Interactive</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.navegg.com/en/privacy-policy">Navegg</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.neodatagroup.com/privacy-policy/">Neodata Group</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.neory.com/privacy.html">NEORY GmbH</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://help.netflix.com/legal/privacy">Netflix</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.nicequest.com/us/privacy">Netquest</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://web.neural.one/privacy-policy/">Neural.ONE</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.home.neustar/privacy">Neustar</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.nextroll.com/privacy">NextRoll, Inc.</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.objectiveplatform.com/cookie-policy-and-privacy-statement">Nielsen</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://numberly.com/en/privacy/">numberly</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.objectiveplatform.com/cookie-policy-and-privacy-statement">Objective Partners</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://omnicommediagroup.com/privacy-notice/">Omnicom Media Group</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://s.on-device.com/privacyPolicy">On Device Research</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.onetag.com/privacy/">OneTag</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.openx.com/privacy-center/ad-exchange-privacy-policy/">OpenX Technologies</a></li><li><a target="_blank" rel="noreferrer noopener" href="http://optomaton.com/privacy.html">Optomaton</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.oracle.com/legal/privacy/advertising-privacy-policy.html">Oracle Data Cloud</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.otto.de/shoppages/service/datenschutz">OTTO</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.permodo.com/datenschutzerklaerung/">PERMODO</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.pixalate.com/privacypolicy">Pixalate</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://platform161.com/cookies-privacy/">Platform161</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.primis.tech/privacy-policy/">Primis</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.protected.media/privacy-policy/">Protected Media</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.publicismedia.de/datenschutz/">Publicis Media</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://pubmatic.com/legal/privacy/">PubMatic</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.pulsepoint.com/legal/platform-privacy-policy">PulsePoint</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.quantcast.com/privacy/">Quantcast</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.rackspace.com/gdpr">Rackspace</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://go.rakutenadvertising.com/hubfs/Services-Privacy-Policy-English.pdf">Rakuten Marketing</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://relay42.com/privacy">Relay42</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.remerge.io/service-privacy-policy">Remerge</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://resolutionagency.com/privacy-policy/">Resolution Media</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.resonate.com/privacy-policy/">Resonate</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.revjet.com/privacy">RevJet</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.roq.ad/privacy-policy-opt-out/">Roq.ad</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.rtbhouse.com/privacy-center">RTB House</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.salesforce.com/company/privacy/">Salesforce DMP</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.scenestealer.sg/">Scenestealer</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.scoota.com/privacy">Scoota</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://career.seenthis.co/privacy-policy">Seenthis</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.semasio.com/privacy">Semasio GmbH</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.sfr.fr/politique-de-protection-des-donnees-personnelles.html">SFR</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.sift.co/privacy-faq">Sift Media</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://simpli.fi/site-privacy-policy/">Simpli.fi</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.sizmek.com/privacy-policy">Sizmek</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.smaato.com/privacy/">Smaato</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://smadex.com/end-user-privacy-policy">Smadex</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://smartadserver.com/end-user-privacy-policy/">Smart</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.smartology.net/privacy-policy/">Smartology</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.sojern.com/privacy/privacy-policy">Sojern</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.solocal.com/protection-de-la-vie-privee">Solocal</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.sovrn.com/legal/privacy-policy/">Sovrn</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://spotad.co/privacy-policy-2/">Spotad</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.stroeer.de/werben-mit-stroeer/onlinewerbung/crossmedia/stroeer-ssp/stroeer-ssp-datenschutz/">STRÖER SSP GmbH</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://hawk-tech.io/privacy-policy/">TabMo</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.taboola.com/policies/privacy-policy">Taboola</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://tacticrealtime.com/privacy/">TACTIC™ Real-Time Marketing</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.teads.com/privacy-policy/">Teads</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://teemo.co/privacy-policy/">TEEMO</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.thetradedesk.com/us/privacy">The Trade Desk</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.tradedoubler.com/en/privacy-policy/">Tradedoubler AB</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://travelaudience.com/product-privacy-notice/">travel audience – An Amadeus Company</a></li><li>Travel Data Collective</li><li><a target="_blank" rel="noreferrer noopener" href="https://liftoff.io/privacy-policy/">TreSensa</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://triplelift.com/privacy/">TripleLift</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://trueffect.ca/privacy-policy/">TruEffect</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://trustarc.com/privacy-policy/">TrustArc</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://unruly.co/legal/privacy/">UnrulyX</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://emego.co.uk/privacy-policy/">usemax (Emego GmbH)</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://pubnative.net/privacy-notice/">Verve Group</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.videologyinc.com/privacy-policy">Videology</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://vimeo.com/cookie_policy">Vimeo</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://virtualminds.de/datenschutz/">Virtual Minds</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.vodafone.de/unternehmen/soziale-verantwortung/datenschutz-privatsphaere.html">Vodafone GmbH</a></li><li>Waystack</li><li><a target="_blank" rel="noreferrer noopener" href="https://weborama.com/respect-de-la-vie-privee-2-2/">Weborama</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.humansecurity.com/privacy">White Ops</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://widespace.teamtailor.com/privacy-policy">Widespace</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://www.wizaly.com/terms-of-use#privacy-policy">Wizaly</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://legal.yahoo.com/ie/en/yahoo/privacy/index.html">Yahoo</a></li><li><a target="_blank" rel="noreferrer noopener" href="https://zms.zalando.com/#">ZMS</a></li></ul><h3 id="how-you-can-control-advertising-cookies">How you can control advertising cookies</h3><p>You can use Ads Settings to manage the FashionUnited ads you see and opt out of interest-based ads. Even if you opt out of interest-based ads, you may still see ads based on factors such as your general location derived from your IP address, your browser type and recent, previous searches related to your current search.</p><p>You can also manage many companies’ cookies used for online advertising at the US-based aboutads.info choices page or the EU-based Your Online Choices.</p><p>Finally, you can manage cookies in your web browser.</p><h2 id="other-technologies-used-in-advertising">Other technologies used in advertising</h2><p>FashionUnited’s advertising systems may use other technologies, including HTML5, for functions like display of interactive ad formats. We may use the IP address, for example, to identify your general location. We may also select advertising based on information about your computer or device, such as your device model, browser type, or sensors in your device like the accelerometer.</p><h3 id="location">Location</h3><p>FashionUnited’s ad products may receive or infer information about your location from a variety of sources. For example, we may use the IP address to identify your general location; we may receive precise location from your mobile device; we may infer your location from your search queries; and websites or apps that you use may send information about your location to us. FashionUnited uses location information in its Google ads products to improve the relevance of the ads you see, to measure ad performance and to report anonymous statistics to advertisers.</p><h3 id="what-determines-the-ads-by-fashionunited-that-i-see">What determines the ads by FashionUnited that I see?</h3><p>Many decisions are made to determine which ad you see.</p><p>In many cases ads are shown via Google Advertising Services. Sometimes the ad you see is based on your location. Your IP address is usually a good indication of your approximate location. So you might see an ad on the homepage of YouTube.com that promotes a forthcoming movie in your country.</p><p>Sometimes the ad you see is based on the context of a page. If you’re looking at a page of gardening tips, you might see ads for gardening equipment.</p><p>Sometimes the ad you see on a page is served by FashionUnited but selected by another company. For example, you might have registered with a newspaper website. From information you’ve given the newspaper, it can make decisions about which ads to show you, and it can use FashionUnited’s ad serving products to deliver those ads.</p><p>Why am I seeing ads by Google for products I’ve viewed?You may see ads for products you previously viewed through what&#39;s known as remarketing. Let’s suppose you visit a website that sells jeans, but you don’t buy those jeans on your first visit. The website owner might want to encourage you to return and complete your purchase. Google offers services that let website operators target their ads to people who visited their pages. Read the <a target="_blank" rel="noreferrer noopener" href="https://policies.google.com/technologies/partner-sites">Google Privacy &amp; Terms site</a> for details about the Google services.</p><p>When you visit another site that works with Google, which may have nothing to do with jeans, you might see an ad for those jeans. That’s because your browser sends Google the same cookie. In turn, we may use that cookie to serve you an ad that could encourage you to buy those jeans.</p><p>Read the <a target="_blank" rel="noreferrer noopener" href="/privacy">Privacy Policy</a>.</p>',
  },
  'cookieConsent.cookies.title': {
    id: 'cookieConsent.cookies.title',
    defaultMessage: 'Cookies',
  },
  'cookieConsent.privacy.message': {
    id: 'cookieConsent.privacy.message',
    defaultMessage: '<h2 id="fashionuniteds-privacy-commitment">FashionUnited’s Privacy Commitment</h2> <p>FashionUnited values your trust in its services and is committed to maintaining that trust and respecting your privacy. FashionUnited ensures that  information is gathered for purposes related to FashionUnited services and will only be used by FashionUnited and will not be sold to third parties. When you contact a third party within the FashionUnited network, this will be stated clearly before you send information. You may, at any time, contact FashionUnited to update, modify, view, correct or remove your personal information from the database.</p> <h2 id="fashionuniteds-promise">FashionUnited’s promise</h2> <p>Since FashionUnited\'s start we have been committed to our users\' privacy and have acted in the GDPR mindset since the beginning, even though it did not exist back then. We are continuously updating the platform and its policies to make it easier for you to understand why and how we process the information you share with us. Through these changes we strive to demonstrate FashionUnited’s work maintaining the trust our users and customers place in us when sharing their data.</p> <ul> <li><p> <a href="#why-does-fashionunited-collect-information-about-me">Why does FashionUnited collect information about me?</a></p> </li> <li><p> <a href="#how-is-my-information-collected">How is my information collected?</a></p> </li> <li><p> <a href="#what-kind-of-information-is-collected">What kind of information is collected?</a></p> </li> <li><p> <a href="#where-and-how-is-the-information-about-me-stored">Where and how is the information about me stored?</a></p> </li> <li><p> <a href="#how-long-will-fashionunited-store-my-information">How long will FashionUnited store my information?</a></p> </li> <li><p> <a href="#will-fashionunited-share-my-data-with-anybody-else">Will FashionUnited share my data with anybody else?</a></p> </li> <li><p> <a href="#what-are-my-rights">What are my rights?</a></p> </li> </ul> <h3 id="why-does-fashionunited-collect-information-about-me">Why does FashionUnited collect information about me?</h3> <p>Keeping in mind the goal of bringing efficiency and transparency to the industry, FashionUnited collects personal and non-personal data for the purposes of recruitment and knowledge sharing.</p> <h3 id="how-is-my-information-collected">How is my information collected?</h3> <p>You share your information with FashionUnited when accessing and using its online and/or mobile services and websites as well as software provided by FashionUnited or in connection with such services or websites. The collected information is relevant to services offered by FashionUnited which include (but are not limited to): career center with job postings and newsletters with the latest developments in the fashion industry. Some of the information you provide yourself, other we collect automatically from your browser.</p> <h3 id="what-kind-of-information-is-collected">What kind of information is collected?</h3> <p>In order to take advantage of newsletter services for the fashion industry, you are asked to share the following personal data: Contact details (first and last name, address, email)</p> <p>In order to take advantage of FashionUnited’s career center and apply for a job, you are asked to share the following personal data:</p> <ul> <li>Contact details (first and last name, address, email)</li> <li>Professional and social profile (CV and cover letter and the information you chose to share in them)</li> <li>Password</li> </ul> <p>Please keep in mind that in the situations when the job posting links to an application form on a third party website (i.e. the employer’s site) FashionUnited accepts no responsibility or liability for any third party practices on third party websites. We advise you to carefully read third party privacy statements prior to the use of any third party website.</p> <p>In order to reach fashion professionals through a job listing on the platform, you are asked to share the following business data:</p> <ul> <li>Business Registration information</li> <li>Contact details (first and last name, address, email) of your company’s representative.</li> </ul> <p>Through your activity on FashionUnited, some information from your computer or mobile device and actions taken on the site can be collected. The information gained is collected so we can customize our response to you. This information may include (and is not limited to):</p> <ul> <li>your activity time on the site and each page</li> <li>page views, clicks</li> <li>session activity</li> <li>Type of device, browser and operating system</li> <li>MAC address and IP address the domain name from which you accessed the Site.</li> </ul> <p>For more information about the technical data FashionUnited might collect, check the Privacy Policy and the Cookie Policy.</p> <h3 id="where-and-how-is-the-information-about-me-stored">Where and how is the information about me stored?</h3> <p>FashionUnited processes and stores your data for the purposes you have given your consent to and to the extent it is adequate. Due to the global presence of FashionUnited, we rely on cloud computing when executing daily tasks. All user data is stored and processed with help of encrypted cloud storage solutions. We are regularly enhancing and updating our security tools, procedures and methods to better protect our your information and anonymity.</p> <p>For more information about how FashionUnited protects the data (encryption, privacy by design, etc.) check the Privacy Policy.</p> <h3 id="how-long-will-fashionunited-store-my-information">How long will FashionUnited store my information?</h3> <p>Your data is stored for the time necessary to provide the service you have requested. When possible, we will provide you with an exact duration; otherwise, refer to the following principles: Your data is held as long as we provide the service you requested (i.e. as long as the recruitment process of the job offer you applied for is open or as long as we offer newsletters or for the duration of the business contract you have with FashionUnited) We take sensitivity of the information into account, when choosing data storage and processing solutions FashionUnited shall not retain Personal Data for any longer than necessary for the purposes of performing the processing outlined in the Privacy Policy. Should we wish to do so for your benefit, your consent will be requested for consent via email.</p> <h3 id="will-fashionunited-share-my-data-with-anybody-else">Will FashionUnited share my data with anybody else?</h3> <p>The information you share with FashionUnited enables us to provide you with the best user experience and service. It is available to FashionUnited and shared with third parties only when relevant. For recruitment purposes for instance, your data is immediately shared with the employer of the job you are applying to, please consult the company advertising the vacancy for their GDPR policy directly. None of your data is being sold to third parties nor shared with anybody without your consent. Your information would only be shared without permission in cases of law infringement.</p> <h3 id="what-are-my-rights">What are my rights?</h3> <p>You are the person in control of how your information is collected and used by organisations, FashionUnited included. You have full right to access, edit, object to, restrict the processing of and delete any personal and non-personal data previously shared with FashionUnited. Should you wish to do so, please write and email to <a href="mailto:privacy@fashionunited.com">privacy@fashionunited.com</a> with a copy of your passport or national identity card attached. We reserve 30 days to process a formal request related to the above.</p> <p>What resources are available to me if I have doubts and/or further questions about my privacy when using FashionUnited? For more information about your privacy and FashionUnited, please check our privacy site, and/or contact us directly at<strong> <a href="mailto:privacy@fashionunited.com">privacy@fashionunited.com</a></strong>. Further information on GDPR specifically can be found at <a href="https://eugdpr.org">eugdpr.org</a>.</p> <p><a href="/privacy-statement">Privacy Policy</a></p> <p><a href="/cookies">Cookie Policy</a></p> <p><a href="https://policies.google.com/technologies/partner-sites">Google\'s Privacy &amp; Terms regarding bannering and advertising</a></p> <p><a href="/conditions">Terms and Conditions</a></p> <p><a href="https://fashionunited.com/tags/gdpr">GDPR in fashion</a></p>',
  },
  'cookieConsent.privacy.title': {
    id: 'cookieConsent.privacy.title',
    defaultMessage: 'Privacy',
  },
  'newsletterForm.title': {
    id: 'newsletterForm.title',
    defaultMessage: 'Yes, I want to subscribe to the newsletter',
  },
  'newsletterForm.mailChimpListId': {
    id: 'newsletterForm.mailChimpListId',
    defaultMessage: '8c24d76aa5',
  },
  'newsletterForm.description': {
    id: 'newsletterForm.description',
    // eslint-disable-next-line max-len
    defaultMessage: '<p>Join the fashion community of entrepreneurs, CEOs, designers, buyers and other fashion professionals already receiving the FashionUnited newsletter.</p><blockquote><strong>Over 250,000 people&nbsp;</strong>are already up-to-date with the latest developments in the industry.&nbsp;<strong>Sign up now!</strong></blockquote><p>By subscribing to the free FashionUnited newsletter you will always be up-to-date with the latest developments in the fashion industry. You will receive newsletters throughout the week on Monday, Wednesday and Friday, and a weekly fashion news highlights overview on Sunday.</p>',
  },
  'newsletterForm.submitLabel': {
    id: 'newsletterForm.submitLabel',
    defaultMessage: 'Yes, keep me up to date',
  },
  'newsletterForm.disclaimerMessage': {
    id: 'newsletterForm.disclaimerMessage',
    // eslint-disable-next-line max-len
    defaultMessage: 'We care about the protection of your data. Read our <a href="/privacy" target="_blank" noreferrer noopener>Privacy Policy.</a>',
  },
  newsletterMetaTitle: {
    id: 'newsletterMetaTitle',
    defaultMessage: 'Subscribe to the newsletter',
  },
  newsletterMetaDescription: {
    id: 'newsletterMetaDescription',
    defaultMessage: 'Subscribe to the American newsletter',
  },
});
